import _get from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var Se = "https://api.stadiamaps.com".replace(/\/+$/, "");
var be = /*#__PURE__*/function () {
  function be() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, be);
    this.configuration = i;
  }
  _createClass(be, [{
    key: "config",
    set: function set(i) {
      this.configuration = i;
    }
  }, {
    key: "basePath",
    get: function get() {
      return this.configuration.basePath != null ? this.configuration.basePath : Se;
    }
  }, {
    key: "fetchApi",
    get: function get() {
      return this.configuration.fetchApi;
    }
  }, {
    key: "middleware",
    get: function get() {
      return this.configuration.middleware || [];
    }
  }, {
    key: "queryParamsStringify",
    get: function get() {
      return this.configuration.queryParamsStringify || B;
    }
  }, {
    key: "username",
    get: function get() {
      return this.configuration.username;
    }
  }, {
    key: "password",
    get: function get() {
      return this.configuration.password;
    }
  }, {
    key: "apiKey",
    get: function get() {
      var i = this.configuration.apiKey;
      if (i) return typeof i == "function" ? i : function () {
        return i;
      };
    }
  }, {
    key: "accessToken",
    get: function get() {
      var i = this.configuration.accessToken;
      if (i) return typeof i == "function" ? i : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", i);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "headers",
    get: function get() {
      return this.configuration.headers;
    }
  }, {
    key: "credentials",
    get: function get() {
      return this.configuration.credentials;
    }
  }]);
  return be;
}();
var Te = new be(),
  D = /*#__PURE__*/function () {
    function D() {
      var _this = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Te;
      _classCallCheck(this, D);
      this.configuration = e, this.fetchApi = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(i, r) {
          var n, _iterator, _step, c, o, _iterator2, _step2, a, _iterator3, _step3, _c2;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                n = {
                  url: i,
                  init: r
                };
                _iterator = _createForOfIteratorHelper(_this.middleware);
                _context2.prev = 2;
                _iterator.s();
              case 4:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 16;
                  break;
                }
                c = _step.value;
                _context2.t0 = c.pre;
                if (!_context2.t0) {
                  _context2.next = 14;
                  break;
                }
                _context2.next = 10;
                return c.pre(_objectSpread({
                  fetch: _this.fetchApi
                }, n));
              case 10:
                _context2.t1 = _context2.sent;
                if (_context2.t1) {
                  _context2.next = 13;
                  break;
                }
                _context2.t1 = n;
              case 13:
                n = _context2.t1;
              case 14:
                _context2.next = 4;
                break;
              case 16:
                _context2.next = 21;
                break;
              case 18:
                _context2.prev = 18;
                _context2.t2 = _context2["catch"](2);
                _iterator.e(_context2.t2);
              case 21:
                _context2.prev = 21;
                _iterator.f();
                return _context2.finish(21);
              case 24:
                _context2.prev = 24;
                _context2.next = 27;
                return (_this.configuration.fetchApi || fetch)(n.url, n.init);
              case 27:
                o = _context2.sent;
                _context2.next = 57;
                break;
              case 30:
                _context2.prev = 30;
                _context2.t3 = _context2["catch"](24);
                _iterator2 = _createForOfIteratorHelper(_this.middleware);
                _context2.prev = 33;
                _iterator2.s();
              case 35:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 47;
                  break;
                }
                a = _step2.value;
                _context2.t4 = a.onError;
                if (!_context2.t4) {
                  _context2.next = 45;
                  break;
                }
                _context2.next = 41;
                return a.onError({
                  fetch: _this.fetchApi,
                  url: n.url,
                  init: n.init,
                  error: _context2.t3,
                  response: o ? o.clone() : void 0
                });
              case 41:
                _context2.t5 = _context2.sent;
                if (_context2.t5) {
                  _context2.next = 44;
                  break;
                }
                _context2.t5 = o;
              case 44:
                o = _context2.t5;
              case 45:
                _context2.next = 35;
                break;
              case 47:
                _context2.next = 52;
                break;
              case 49:
                _context2.prev = 49;
                _context2.t6 = _context2["catch"](33);
                _iterator2.e(_context2.t6);
              case 52:
                _context2.prev = 52;
                _iterator2.f();
                return _context2.finish(52);
              case 55:
                if (!(o === void 0)) {
                  _context2.next = 57;
                  break;
                }
                throw _context2.t3 instanceof Error ? new Je(_context2.t3, "The request failed and the interceptors did not return an alternative response") : _context2.t3;
              case 57:
                _iterator3 = _createForOfIteratorHelper(_this.middleware);
                _context2.prev = 58;
                _iterator3.s();
              case 60:
                if ((_step3 = _iterator3.n()).done) {
                  _context2.next = 72;
                  break;
                }
                _c2 = _step3.value;
                _context2.t7 = _c2.post;
                if (!_context2.t7) {
                  _context2.next = 70;
                  break;
                }
                _context2.next = 66;
                return _c2.post({
                  fetch: _this.fetchApi,
                  url: n.url,
                  init: n.init,
                  response: o.clone()
                });
              case 66:
                _context2.t8 = _context2.sent;
                if (_context2.t8) {
                  _context2.next = 69;
                  break;
                }
                _context2.t8 = o;
              case 69:
                o = _context2.t8;
              case 70:
                _context2.next = 60;
                break;
              case 72:
                _context2.next = 77;
                break;
              case 74:
                _context2.prev = 74;
                _context2.t9 = _context2["catch"](58);
                _iterator3.e(_context2.t9);
              case 77:
                _context2.prev = 77;
                _iterator3.f();
                return _context2.finish(77);
              case 80:
                return _context2.abrupt("return", o);
              case 81:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[2, 18, 21, 24], [24, 30], [33, 49, 52, 55], [58, 74, 77, 80]]);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }(), this.middleware = e.middleware;
    }
    _createClass(D, [{
      key: "withMiddleware",
      value: function withMiddleware() {
        var _i$middleware;
        var i = this.clone();
        return i.middleware = (_i$middleware = i.middleware).concat.apply(_i$middleware, arguments), i;
      }
    }, {
      key: "withPreMiddleware",
      value: function withPreMiddleware() {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        var i = e.map(function (r) {
          return {
            pre: r
          };
        });
        return this.withMiddleware.apply(this, _toConsumableArray(i));
      }
    }, {
      key: "withPostMiddleware",
      value: function withPostMiddleware() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        var i = e.map(function (r) {
          return {
            post: r
          };
        });
        return this.withMiddleware.apply(this, _toConsumableArray(i));
      }
      /**
       * Check if the given MIME is a JSON MIME.
       * JSON MIME examples:
       *   application/json
       *   application/json; charset=UTF8
       *   APPLICATION/JSON
       *   application/vnd.company+json
       * @param mime - MIME (Multipurpose Internet Mail Extensions)
       * @return True if the given MIME is JSON, false otherwise.
       */
    }, {
      key: "isJsonMime",
      value: function isJsonMime(e) {
        return e ? D.jsonRegex.test(e) : !1;
      }
    }, {
      key: "request",
      value: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, i) {
          var _yield$this$createFet, r, n, o;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.createFetchParams(e, i);
              case 2:
                _yield$this$createFet = _context3.sent;
                r = _yield$this$createFet.url;
                n = _yield$this$createFet.init;
                _context3.next = 7;
                return this.fetchApi(r, n);
              case 7:
                o = _context3.sent;
                if (!(o && o.status >= 200 && o.status < 300)) {
                  _context3.next = 10;
                  break;
                }
                return _context3.abrupt("return", o);
              case 10:
                throw new Re(o, "Response returned an error code");
              case 11:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function request(_x3, _x4) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    }, {
      key: "createFetchParams",
      value: function () {
        var _createFetchParams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e, i) {
          var r, n, o, c, a, ve;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                r = this.configuration.basePath + e.path;
                e.query !== void 0 && Object.keys(e.query).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(e.query));
                n = Object.assign({}, this.configuration.headers, e.headers);
                Object.keys(n).forEach(function (E) {
                  return n[E] === void 0 ? delete n[E] : {};
                });
                o = typeof i == "function" ? i : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", i);
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                c = {
                  method: e.method,
                  headers: n,
                  body: e.body,
                  credentials: this.configuration.credentials
                };
                _context5.t0 = _objectSpread;
                _context5.t1 = {};
                _context5.t2 = c;
                _context5.next = 11;
                return o({
                  init: c,
                  context: e
                });
              case 11:
                _context5.t3 = _context5.sent;
                a = (0, _context5.t0)(_context5.t1, _context5.t2, _context5.t3);
                ve = _objectSpread({}, a, {
                  body: Ne(a.body) || a.body instanceof URLSearchParams || we(a.body) ? a.body : JSON.stringify(a.body)
                });
                return _context5.abrupt("return", {
                  url: r,
                  init: ve
                });
              case 15:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function createFetchParams(_x5, _x6) {
          return _createFetchParams.apply(this, arguments);
        }
        return createFetchParams;
      }()
      /**
       * Create a shallow clone of `this` by constructing a new instance
       * and then shallow cloning data members.
       */
    }, {
      key: "clone",
      value: function clone() {
        var e = this.constructor,
          i = new e(this.configuration);
        return i.middleware = this.middleware.slice(), i;
      }
    }]);
    return D;
  }();
var b = D;
b.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
function we(e) {
  return typeof Blob < "u" && e instanceof Blob;
}
function Ne(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
var Re = /*#__PURE__*/function (_Error) {
  _inherits(Re, _Error);
  function Re(i, r) {
    var _this2;
    _classCallCheck(this, Re);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Re).call(this, r)), _this2.response = i, _this2.name = "ResponseError";
    return _this2;
  }
  return Re;
}(_wrapNativeSuper(Error));
var Je = /*#__PURE__*/function (_Error2) {
  _inherits(Je, _Error2);
  function Je(i, r) {
    var _this3;
    _classCallCheck(this, Je);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Je).call(this, r)), _this3.cause = i, _this3.name = "FetchError";
    return _this3;
  }
  return Je;
}(_wrapNativeSuper(Error));
var g = /*#__PURE__*/function (_Error3) {
  _inherits(g, _Error3);
  function g(i, r) {
    var _this4;
    _classCallCheck(this, g);
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, r)), _this4.field = i, _this4.name = "RequiredError";
    return _this4;
  }
  return g;
}(_wrapNativeSuper(Error));
var s = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function t(e, i) {
  var r = e[i];
  return r != null;
}
function B(e) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return Object.keys(e).map(function (r) {
    return G(r, e[r], i);
  }).filter(function (r) {
    return r.length > 0;
  }).join("&");
}
function G(e, i) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var n = r + (r.length ? "[".concat(e, "]") : e);
  if (i instanceof Array) {
    var o = i.map(function (c) {
      return encodeURIComponent(String(c));
    }).join("&".concat(encodeURIComponent(n), "="));
    return "".concat(encodeURIComponent(n), "=").concat(o);
  }
  if (i instanceof Set) {
    var _o2 = Array.from(i);
    return G(e, _o2, r);
  }
  return i instanceof Date ? "".concat(encodeURIComponent(n), "=").concat(encodeURIComponent(i.toISOString())) : i instanceof Object ? B(i, n) : "".concat(encodeURIComponent(n), "=").concat(encodeURIComponent(String(i)));
}
function jn(e, i) {
  return Object.keys(e).reduce(function (r, n) {
    return _objectSpread({}, r, _defineProperty({}, n, i(e[n])));
  }, {});
}
function er(e) {
  var _iterator4 = _createForOfIteratorHelper(e),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var i = _step4.value;
      if (i.contentType === "multipart/form-data") return !0;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return !1;
}
var d = /*#__PURE__*/function () {
  function d(i) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (n) {
      return n;
    };
    _classCallCheck(this, d);
    this.raw = i, this.transformer = r;
  }
  _createClass(d, [{
    key: "value",
    value: function () {
      var _value = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = this;
              _context6.next = 3;
              return this.raw.json();
            case 3:
              _context6.t1 = _context6.sent;
              return _context6.abrupt("return", _context6.t0.transformer.call(_context6.t0, _context6.t1));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function value() {
        return _value.apply(this, arguments);
      }
      return value;
    }()
  }]);
  return d;
}();
var ir = /*#__PURE__*/function () {
  function ir(i) {
    _classCallCheck(this, ir);
    this.raw = i;
  }
  _createClass(ir, [{
    key: "value",
    value: function () {
      var _value2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function value() {
        return _value2.apply(this, arguments);
      }
      return value;
    }()
  }]);
  return ir;
}();
var tr = /*#__PURE__*/function () {
  function tr(i) {
    _classCallCheck(this, tr);
    this.raw = i;
  }
  _createClass(tr, [{
    key: "value",
    value: function () {
      var _value3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.raw.blob();
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function value() {
        return _value3.apply(this, arguments);
      }
      return value;
    }()
  }]);
  return tr;
}();
var nr = /*#__PURE__*/function () {
  function nr(i) {
    _classCallCheck(this, nr);
    this.raw = i;
  }
  _createClass(nr, [{
    key: "value",
    value: function () {
      var _value4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.raw.text();
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function value() {
        return _value4.apply(this, arguments);
      }
      return value;
    }()
  }]);
  return nr;
}();
function rr(e) {
  return !0;
}
function H(e) {
  return Ce(e);
}
function Ce(e, i) {
  return e == null ? e : {
    golfCart: t(e, "golf_cart") ? e.golf_cart : void 0,
    wheelchair: t(e, "wheelchair") ? e.wheelchair : void 0,
    taxi: t(e, "taxi") ? e.taxi : void 0,
    hOV: t(e, "HOV") ? e.HOV : void 0,
    truck: t(e, "truck") ? e.truck : void 0,
    emergency: t(e, "emergency") ? e.emergency : void 0,
    pedestrian: t(e, "pedestrian") ? e.pedestrian : void 0,
    car: t(e, "car") ? e.car : void 0,
    bus: t(e, "bus") ? e.bus : void 0,
    bicycle: t(e, "bicycle") ? e.bicycle : void 0,
    motorcycle: t(e, "motorcycle") ? e.motorcycle : void 0,
    moped: t(e, "moped") ? e.moped : void 0
  };
}
function W(e) {
  if (e !== void 0) return e === null ? null : {
    golf_cart: e.golfCart,
    wheelchair: e.wheelchair,
    taxi: e.taxi,
    HOV: e.hOV,
    truck: e.truck,
    emergency: e.emergency,
    pedestrian: e.pedestrian,
    car: e.car,
    bus: e.bus,
    bicycle: e.bicycle,
    motorcycle: e.motorcycle,
    moped: e.moped
  };
}
function or(e) {
  return !0;
}
function z(e) {
  return Fe(e);
}
function Fe(e, i) {
  return e == null ? e : {
    countryCode: t(e, "country_code") ? e.country_code : void 0,
    countryText: t(e, "country_text") ? e.country_text : void 0,
    stateCode: t(e, "state_code") ? e.state_code : void 0,
    stateText: t(e, "state_text") ? e.state_text : void 0
  };
}
function U(e) {
  if (e !== void 0) return e === null ? null : {
    country_code: e.countryCode,
    country_text: e.countryText,
    state_code: e.stateCode,
    state_text: e.stateText
  };
}
function cr(e) {
  return !0;
}
function K(e) {
  return xe(e);
}
function xe(e, i) {
  return e == null ? e : {
    iso31661: t(e, "iso_3166-1") ? e["iso_3166-1"] : void 0,
    country: t(e, "country") ? e.country : void 0,
    iso31662: t(e, "iso_3166-2") ? e["iso_3166-2"] : void 0,
    state: t(e, "state") ? e.state : void 0
  };
}
function V(e) {
  if (e !== void 0) return e === null ? null : {
    "iso_3166-1": e.iso31661,
    country: e.country,
    "iso_3166-2": e.iso31662,
    state: e.state
  };
}
function ar(e) {
  return !0;
}
function R(e) {
  return ke(e);
}
function ke(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    tollBoothCost: t(e, "toll_booth_cost") ? e.toll_booth_cost : void 0,
    tollBoothPenalty: t(e, "toll_booth_penalty") ? e.toll_booth_penalty : void 0,
    ferryCost: t(e, "ferry_cost") ? e.ferry_cost : void 0,
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTolls: t(e, "use_tolls") ? e.use_tolls : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    topSpeed: t(e, "top_speed") ? e.top_speed : void 0,
    shortest: t(e, "shortest") ? e.shortest : void 0,
    ignoreClosures: t(e, "ignore_closures") ? e.ignore_closures : void 0,
    includeHov2: t(e, "include_hov2") ? e.include_hov2 : void 0,
    includeHov3: t(e, "include_hov3") ? e.include_hov3 : void 0,
    includeHot: t(e, "include_hot") ? e.include_hot : void 0
  };
}
function J(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry,
    height: e.height,
    width: e.width,
    toll_booth_cost: e.tollBoothCost,
    toll_booth_penalty: e.tollBoothPenalty,
    ferry_cost: e.ferryCost,
    use_highways: e.useHighways,
    use_tolls: e.useTolls,
    use_tracks: e.useTracks,
    top_speed: e.topSpeed,
    shortest: e.shortest,
    ignore_closures: e.ignoreClosures,
    include_hov2: e.includeHov2,
    include_hov3: e.includeHov3,
    include_hot: e.includeHot
  };
}
function dr(e) {
  return !0;
}
function sr(e) {
  return Ie(e);
}
function Ie(e, i) {
  return e == null ? e : {
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    tollBoothCost: t(e, "toll_booth_cost") ? e.toll_booth_cost : void 0,
    tollBoothPenalty: t(e, "toll_booth_penalty") ? e.toll_booth_penalty : void 0,
    ferryCost: t(e, "ferry_cost") ? e.ferry_cost : void 0,
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTolls: t(e, "use_tolls") ? e.use_tolls : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    topSpeed: t(e, "top_speed") ? e.top_speed : void 0,
    shortest: t(e, "shortest") ? e.shortest : void 0,
    ignoreClosures: t(e, "ignore_closures") ? e.ignore_closures : void 0,
    includeHov2: t(e, "include_hov2") ? e.include_hov2 : void 0,
    includeHov3: t(e, "include_hov3") ? e.include_hov3 : void 0,
    includeHot: t(e, "include_hot") ? e.include_hot : void 0
  };
}
function ur(e) {
  if (e !== void 0) return e === null ? null : {
    height: e.height,
    width: e.width,
    toll_booth_cost: e.tollBoothCost,
    toll_booth_penalty: e.tollBoothPenalty,
    ferry_cost: e.ferryCost,
    use_highways: e.useHighways,
    use_tolls: e.useTolls,
    use_tracks: e.useTracks,
    top_speed: e.topSpeed,
    shortest: e.shortest,
    ignore_closures: e.ignoreClosures,
    include_hov2: e.includeHov2,
    include_hov3: e.includeHov3,
    include_hot: e.includeHot
  };
}
function lr(e) {
  return !0;
}
function gr(e) {
  return Me(e);
}
function Me(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0
  };
}
function pr(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry
  };
}
var _r = {
  Road: "Road",
  Hybrid: "Hybrid",
  Cross: "Cross",
  Mountain: "Mountain"
};
function fr(e) {
  return !0;
}
function Ee(e) {
  return Ae(e);
}
function Ae(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    bicycleType: t(e, "bicycle_type") ? e.bicycle_type : void 0,
    cyclingSpeed: t(e, "cycling_speed") ? e.cycling_speed : void 0,
    useRoads: t(e, "use_roads") ? e.use_roads : void 0,
    useHills: t(e, "use_hills") ? e.use_hills : void 0,
    avoidBadSurfaces: t(e, "avoid_bad_surfaces") ? e.avoid_bad_surfaces : void 0,
    bssReturnCost: t(e, "bss_return_cost") ? e.bss_return_cost : void 0,
    bssReturnPenalty: t(e, "bss_return_penalty") ? e.bss_return_penalty : void 0
  };
}
function Le(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry,
    bicycle_type: e.bicycleType,
    cycling_speed: e.cyclingSpeed,
    use_roads: e.useRoads,
    use_hills: e.useHills,
    avoid_bad_surfaces: e.avoidBadSurfaces,
    bss_return_cost: e.bssReturnCost,
    bss_return_penalty: e.bssReturnPenalty
  };
}
function yr(e) {
  return !0;
}
function Pe(e) {
  return De(e);
}
function De(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    tollBoothCost: t(e, "toll_booth_cost") ? e.toll_booth_cost : void 0,
    tollBoothPenalty: t(e, "toll_booth_penalty") ? e.toll_booth_penalty : void 0,
    ferryCost: t(e, "ferry_cost") ? e.ferry_cost : void 0,
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTolls: t(e, "use_tolls") ? e.use_tolls : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    topSpeed: t(e, "top_speed") ? e.top_speed : void 0,
    shortest: t(e, "shortest") ? e.shortest : void 0,
    ignoreClosures: t(e, "ignore_closures") ? e.ignore_closures : void 0,
    includeHov2: t(e, "include_hov2") ? e.include_hov2 : void 0,
    includeHov3: t(e, "include_hov3") ? e.include_hov3 : void 0,
    includeHot: t(e, "include_hot") ? e.include_hot : void 0,
    usePrimary: t(e, "use_primary") ? e.use_primary : void 0,
    useHills: t(e, "use_hills") ? e.use_hills : void 0
  };
}
function Be(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry,
    height: e.height,
    width: e.width,
    toll_booth_cost: e.tollBoothCost,
    toll_booth_penalty: e.tollBoothPenalty,
    ferry_cost: e.ferryCost,
    use_highways: e.useHighways,
    use_tolls: e.useTolls,
    use_tracks: e.useTracks,
    top_speed: e.topSpeed,
    shortest: e.shortest,
    ignore_closures: e.ignoreClosures,
    include_hov2: e.includeHov2,
    include_hov3: e.includeHov3,
    include_hot: e.includeHot,
    use_primary: e.usePrimary,
    use_hills: e.useHills
  };
}
function hr(e) {
  return !0;
}
function Ge(e) {
  return He(e);
}
function He(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    tollBoothCost: t(e, "toll_booth_cost") ? e.toll_booth_cost : void 0,
    tollBoothPenalty: t(e, "toll_booth_penalty") ? e.toll_booth_penalty : void 0,
    ferryCost: t(e, "ferry_cost") ? e.ferry_cost : void 0,
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTolls: t(e, "use_tolls") ? e.use_tolls : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    topSpeed: t(e, "top_speed") ? e.top_speed : void 0,
    shortest: t(e, "shortest") ? e.shortest : void 0,
    ignoreClosures: t(e, "ignore_closures") ? e.ignore_closures : void 0,
    includeHov2: t(e, "include_hov2") ? e.include_hov2 : void 0,
    includeHov3: t(e, "include_hov3") ? e.include_hov3 : void 0,
    includeHot: t(e, "include_hot") ? e.include_hot : void 0,
    useTrails: t(e, "use_trails") ? e.use_trails : void 0
  };
}
function We(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry,
    height: e.height,
    width: e.width,
    toll_booth_cost: e.tollBoothCost,
    toll_booth_penalty: e.tollBoothPenalty,
    ferry_cost: e.ferryCost,
    use_highways: e.useHighways,
    use_tolls: e.useTolls,
    use_tracks: e.useTracks,
    top_speed: e.topSpeed,
    shortest: e.shortest,
    ignore_closures: e.ignoreClosures,
    include_hov2: e.includeHov2,
    include_hov3: e.includeHov3,
    include_hot: e.includeHot,
    use_trails: e.useTrails
  };
}
function mr(e) {
  return !0;
}
function ze(e) {
  return Ue(e);
}
function Ue(e, i) {
  return e == null ? e : {
    walkingSpeed: t(e, "walking_speed") ? e.walking_speed : void 0,
    walkwayFactor: t(e, "walkway_factor") ? e.walkway_factor : void 0,
    sidewalkFactor: t(e, "sidewalk_factor") ? e.sidewalk_factor : void 0,
    alleyFactor: t(e, "alley_factor") ? e.alley_factor : void 0,
    drivewayFactor: t(e, "driveway_factor") ? e.driveway_factor : void 0,
    stepPenalty: t(e, "step_penalty") ? e.step_penalty : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    useHills: t(e, "use_hills") ? e.use_hills : void 0,
    useLit: t(e, "use_lit") ? e.use_lit : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    maxHikingDifficulty: t(e, "max_hiking_difficulty") ? e.max_hiking_difficulty : void 0,
    bssRentCost: t(e, "bss_rent_cost") ? e.bss_rent_cost : void 0,
    bssRentPenalty: t(e, "bss_rent_penalty") ? e.bss_rent_penalty : void 0
  };
}
function Ke(e) {
  if (e !== void 0) return e === null ? null : {
    walking_speed: e.walkingSpeed,
    walkway_factor: e.walkwayFactor,
    sidewalk_factor: e.sidewalkFactor,
    alley_factor: e.alleyFactor,
    driveway_factor: e.drivewayFactor,
    step_penalty: e.stepPenalty,
    use_ferry: e.useFerry,
    use_living_streets: e.useLivingStreets,
    use_tracks: e.useTracks,
    use_hills: e.useHills,
    use_lit: e.useLit,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    max_hiking_difficulty: e.maxHikingDifficulty,
    bss_rent_cost: e.bssRentCost,
    bss_rent_penalty: e.bssRentPenalty
  };
}
function Or(e) {
  return !0;
}
function Ve(e) {
  return $e(e);
}
function $e(e, i) {
  return e == null ? e : {
    maneuverPenalty: t(e, "maneuver_penalty") ? e.maneuver_penalty : void 0,
    gateCost: t(e, "gate_cost") ? e.gate_cost : void 0,
    gatePenalty: t(e, "gate_penalty") ? e.gate_penalty : void 0,
    countryCrossingCost: t(e, "country_crossing_cost") ? e.country_crossing_cost : void 0,
    countryCrossingPenalty: t(e, "country_crossing_penalty") ? e.country_crossing_penalty : void 0,
    servicePenalty: t(e, "service_penalty") ? e.service_penalty : void 0,
    serviceFactor: t(e, "service_factor") ? e.service_factor : void 0,
    useLivingStreets: t(e, "use_living_streets") ? e.use_living_streets : void 0,
    useFerry: t(e, "use_ferry") ? e.use_ferry : void 0,
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    tollBoothCost: t(e, "toll_booth_cost") ? e.toll_booth_cost : void 0,
    tollBoothPenalty: t(e, "toll_booth_penalty") ? e.toll_booth_penalty : void 0,
    ferryCost: t(e, "ferry_cost") ? e.ferry_cost : void 0,
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTolls: t(e, "use_tolls") ? e.use_tolls : void 0,
    useTracks: t(e, "use_tracks") ? e.use_tracks : void 0,
    topSpeed: t(e, "top_speed") ? e.top_speed : void 0,
    shortest: t(e, "shortest") ? e.shortest : void 0,
    ignoreClosures: t(e, "ignore_closures") ? e.ignore_closures : void 0,
    includeHov2: t(e, "include_hov2") ? e.include_hov2 : void 0,
    includeHov3: t(e, "include_hov3") ? e.include_hov3 : void 0,
    includeHot: t(e, "include_hot") ? e.include_hot : void 0,
    length: t(e, "length") ? e.length : void 0,
    weight: t(e, "weight") ? e.weight : void 0,
    axleLoad: t(e, "axle_load") ? e.axle_load : void 0,
    hazmat: t(e, "hazmat") ? e.hazmat : void 0
  };
}
function Ze(e) {
  if (e !== void 0) return e === null ? null : {
    maneuver_penalty: e.maneuverPenalty,
    gate_cost: e.gateCost,
    gate_penalty: e.gatePenalty,
    country_crossing_cost: e.countryCrossingCost,
    country_crossing_penalty: e.countryCrossingPenalty,
    service_penalty: e.servicePenalty,
    service_factor: e.serviceFactor,
    use_living_streets: e.useLivingStreets,
    use_ferry: e.useFerry,
    height: e.height,
    width: e.width,
    toll_booth_cost: e.tollBoothCost,
    toll_booth_penalty: e.tollBoothPenalty,
    ferry_cost: e.ferryCost,
    use_highways: e.useHighways,
    use_tolls: e.useTolls,
    use_tracks: e.useTracks,
    top_speed: e.topSpeed,
    shortest: e.shortest,
    ignore_closures: e.ignoreClosures,
    include_hov2: e.includeHov2,
    include_hov3: e.includeHov3,
    include_hot: e.includeHot,
    length: e.length,
    weight: e.weight,
    axle_load: e.axleLoad,
    hazmat: e.hazmat
  };
}
function vr(e) {
  return !0;
}
function u(e) {
  return Xe(e);
}
function Xe(e, i) {
  return e == null ? e : {
    auto: t(e, "auto") ? R(e.auto) : void 0,
    bus: t(e, "bus") ? R(e.bus) : void 0,
    taxi: t(e, "taxi") ? R(e.taxi) : void 0,
    truck: t(e, "truck") ? Ve(e.truck) : void 0,
    bicycle: t(e, "bicycle") ? Ee(e.bicycle) : void 0,
    motorScooter: t(e, "motor_scooter") ? Pe(e.motor_scooter) : void 0,
    motorcycle: t(e, "motorcycle") ? Ge(e.motorcycle) : void 0,
    pedestrian: t(e, "pedestrian") ? ze(e.pedestrian) : void 0
  };
}
function l(e) {
  if (e !== void 0) return e === null ? null : {
    auto: J(e.auto),
    bus: J(e.bus),
    taxi: J(e.taxi),
    truck: Ze(e.truck),
    bicycle: Le(e.bicycle),
    motor_scooter: Be(e.motorScooter),
    motorcycle: We(e.motorcycle),
    pedestrian: Ke(e.pedestrian)
  };
}
var Sr = {
  Km: "km",
  Mi: "mi"
};
function Qe(e) {
  return Ye(e);
}
function Ye(e, i) {
  return e;
}
function br(e) {
  return e;
}
var Tr = {
  BgBg: "bg-BG",
  CaEs: "ca-ES",
  CsCz: "cs-CZ",
  DaDk: "da-DK",
  DeDe: "de-DE",
  ElGr: "el-GR",
  EnGb: "en-GB",
  EnUsXPirate: "en-US-x-pirate",
  EnUs: "en-US",
  EsEs: "es-ES",
  EtEe: "et-EE",
  FiFi: "fi-FI",
  FrFr: "fr-FR",
  HiIn: "hi-IN",
  HuHu: "hu-HU",
  ItIt: "it-IT",
  JaJp: "ja-JP",
  NbNo: "nb-NO",
  NlNl: "nl-NL",
  PlPl: "pl-PL",
  PtBr: "pt-BR",
  PtPt: "pt-PT",
  RoRo: "ro-RO",
  RuRu: "ru-RU",
  SkSk: "sk-SK",
  SlSi: "sl-SI",
  SvSe: "sv-SE",
  TrTr: "tr-TR",
  UkUa: "uk-UA"
};
function $(e) {
  return qe(e);
}
function qe(e, i) {
  return e;
}
function wr(e) {
  return e;
}
var Nr = {
  None: "none",
  Maneuvers: "maneuvers",
  Instructions: "instructions"
};
function Rr(e) {
  return !0;
}
function f(e) {
  return je(e);
}
function je(e, i) {
  return e == null ? e : {
    units: t(e, "units") ? Qe(e.units) : void 0,
    language: t(e, "language") ? $(e.language) : void 0,
    directionsType: t(e, "directions_type") ? e.directions_type : void 0
  };
}
function y(e) {
  if (e !== void 0) return e === null ? null : {
    units: e.units,
    language: e.language,
    directions_type: e.directionsType
  };
}
var Jr = {
  Auto: "auto",
  Bicycle: "bicycle",
  Bus: "bus",
  Pedestrian: "pedestrian"
};
function x(e) {
  return ei(e);
}
function ei(e, i) {
  return e;
}
function Cr(e) {
  return e;
}
var Fr = {
  Break: "break",
  Through: "through",
  Via: "via",
  BreakThrough: "break_through"
};
function xr(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function k(e) {
  return ii(e);
}
function ii(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    type: t(e, "type") ? e.type : void 0,
    time: t(e, "time") ? e.time : void 0
  };
}
function I(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    type: e.type,
    time: e.time
  };
}
var kr = {
  EdgeWalk: "edge_walk",
  MapSnap: "map_snap",
  WalkOrSnap: "walk_or_snap"
};
function Ir(e) {
  var i = !0;
  return i = i && "costing" in e, i;
}
function Mr(e) {
  return ti(e);
}
function ti(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    shape: t(e, "shape") ? e.shape.map(k) : void 0,
    encodedPolyline: t(e, "encoded_polyline") ? e.encoded_polyline : void 0,
    costing: x(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    shapeMatch: t(e, "shape_match") ? e.shape_match : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0
  };
}
function Er(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    shape: e.shape === void 0 ? void 0 : e.shape.map(I),
    encoded_polyline: e.encodedPolyline,
    costing: e.costing,
    costing_options: l(e.costingOptions),
    shape_match: e.shapeMatch,
    directions_options: y(e.directionsOptions)
  };
}
var Ar = {
  Road: "Road",
  Hybrid: "Hybrid",
  Cross: "Cross",
  Mountain: "Mountain"
};
function Lr(e) {
  return !0;
}
function Pr(e) {
  return ni(e);
}
function ni(e, i) {
  return e == null ? e : {
    bicycleType: t(e, "bicycle_type") ? e.bicycle_type : void 0,
    cyclingSpeed: t(e, "cycling_speed") ? e.cycling_speed : void 0,
    useRoads: t(e, "use_roads") ? e.use_roads : void 0,
    useHills: t(e, "use_hills") ? e.use_hills : void 0,
    avoidBadSurfaces: t(e, "avoid_bad_surfaces") ? e.avoid_bad_surfaces : void 0,
    bssReturnCost: t(e, "bss_return_cost") ? e.bss_return_cost : void 0,
    bssReturnPenalty: t(e, "bss_return_penalty") ? e.bss_return_penalty : void 0
  };
}
function Dr(e) {
  if (e !== void 0) return e === null ? null : {
    bicycle_type: e.bicycleType,
    cycling_speed: e.cyclingSpeed,
    use_roads: e.useRoads,
    use_hills: e.useHills,
    avoid_bad_surfaces: e.avoidBadSurfaces,
    bss_return_cost: e.bssReturnCost,
    bss_return_penalty: e.bssReturnPenalty
  };
}
function Br(e) {
  return !0;
}
function ri(e) {
  return oi(e);
}
function oi(e, i) {
  return e == null ? e : {
    mountain: t(e, "mountain") ? e.mountain : void 0,
    local: t(e, "local") ? e.local : void 0,
    regional: t(e, "regional") ? e.regional : void 0,
    national: t(e, "national") ? e.national : void 0
  };
}
function ci(e) {
  if (e !== void 0) return e === null ? null : {
    mountain: e.mountain,
    local: e.local,
    regional: e.regional,
    national: e.national
  };
}
function Gr(e) {
  return !0;
}
function ai(e) {
  return di(e);
}
function di(e, i) {
  return e == null ? e : {
    time: t(e, "time") ? e.time : void 0,
    distance: t(e, "distance") ? e.distance : void 0,
    color: t(e, "color") ? e.color : void 0
  };
}
function si(e) {
  if (e !== void 0) return e === null ? null : {
    time: e.time,
    distance: e.distance,
    color: e.color
  };
}
function Hr(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function p(e) {
  return ui(e);
}
function ui(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon
  };
}
function _(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon
  };
}
var Wr = {
  Auto: "auto",
  Bus: "bus",
  Taxi: "taxi",
  Truck: "truck",
  Bicycle: "bicycle",
  Bikeshare: "bikeshare",
  MotorScooter: "motor_scooter",
  Motorcycle: "motorcycle",
  Pedestrian: "pedestrian"
};
function Z(e) {
  return li(e);
}
function li(e, i) {
  return e;
}
function zr(e) {
  return e;
}
function Ur(e) {
  return !0;
}
function gi(e) {
  return pi(e);
}
function pi(e, i) {
  return e == null ? e : {
    exitNumber: t(e, "exit_number") ? e.exit_number : void 0,
    exitBranch: t(e, "exit_branch") ? e.exit_branch : void 0,
    exitToward: t(e, "exit_toward") ? e.exit_toward : void 0,
    exitName: t(e, "exit_name") ? e.exit_name : void 0
  };
}
function _i(e) {
  if (e !== void 0) return e === null ? null : {
    exit_number: e.exitNumber,
    exit_branch: e.exitBranch,
    exit_toward: e.exitToward,
    exit_name: e.exitName
  };
}
var Kr = {
  Road: "road",
  Ramp: "ramp",
  TurnChannel: "turn_channel",
  Track: "track",
  Driveway: "driveway",
  Alley: "alley",
  ParkingAisle: "parking_aisle",
  EmergencyAccess: "emergency_access",
  DriveThrough: "drive_through",
  Culdesac: "culdesac",
  LivingStreet: "living_street",
  ServiceRoad: "service_road",
  Cycleway: "cycleway",
  MountainBike: "mountain_bike",
  Sidewalk: "sidewalk",
  Footway: "footway",
  Steps: "steps",
  Path: "path",
  Pedestrian: "pedestrian",
  PedestrianCrossing: "pedestrian_crossing",
  Bridleway: "bridleway",
  RestArea: "rest_area",
  ServiceArea: "service_area",
  Other: "other",
  Ferry: "ferry",
  RailFerry: "rail-ferry",
  Rail: "rail",
  Bus: "bus",
  EgressConnection: "egress_connection",
  PlatformConnection: "platform_connection",
  TransitConnection: "transit_connection"
};
function X(e) {
  return fi(e);
}
function fi(e, i) {
  return e;
}
function Vr(e) {
  return e;
}
var $r = {
  Motorway: "motorway",
  Trunk: "trunk",
  Primary: "primary",
  Secondary: "secondary",
  Tertiary: "tertiary",
  Unclassified: "unclassified",
  Residential: "residential",
  ServiceOther: "service_other"
};
function S(e) {
  return yi(e);
}
function yi(e, i) {
  return e;
}
function Zr(e) {
  return e;
}
var Xr = {
  Forward: "forward",
  Backward: "backward",
  Both: "both"
};
function v(e) {
  return hi(e);
}
function hi(e, i) {
  return e;
}
function Qr(e) {
  return e;
}
function Yr(e) {
  return !0;
}
function mi(e) {
  return Oi(e);
}
function Oi(e, i) {
  return e == null ? e : {
    beginHeading: t(e, "begin_heading") ? e.begin_heading : void 0,
    fromEdgeNameConsistency: t(e, "from_edge_name_consistency") ? e.from_edge_name_consistency : void 0,
    toEdgeNameConsistency: t(e, "to_edge_name_consistency") ? e.to_edge_name_consistency : void 0,
    driveability: t(e, "driveability") ? v(e.driveability) : void 0,
    cyclability: t(e, "cyclability") ? v(e.cyclability) : void 0,
    walkability: t(e, "walkability") ? v(e.walkability) : void 0,
    use: t(e, "use") ? X(e.use) : void 0,
    roadClass: t(e, "road_class") ? S(e.road_class) : void 0
  };
}
function vi(e) {
  if (e !== void 0) return e === null ? null : {
    begin_heading: e.beginHeading,
    from_edge_name_consistency: e.fromEdgeNameConsistency,
    to_edge_name_consistency: e.toEdgeNameConsistency,
    driveability: e.driveability,
    cyclability: e.cyclability,
    walkability: e.walkability,
    use: e.use,
    road_class: e.roadClass
  };
}
var qr = {
  StreetIntersection: "street_intersection",
  Gate: "gate",
  Bollard: "bollard",
  TollBooth: "toll_booth",
  MultiUseTransitStop: "multi_use_transit_stop",
  BikeShare: "bike_share",
  Parking: "parking",
  MotorWayJunction: "motor_way_junction",
  BorderControl: "border_control"
};
function M(e) {
  return Si(e);
}
function Si(e, i) {
  return e;
}
function jr(e) {
  return e;
}
function eo(e) {
  return !0;
}
function bi(e) {
  return Ti(e);
}
function Ti(e, i) {
  return e == null ? e : {
    intersectingEdges: t(e, "intersecting_edges") ? e.intersecting_edges.map(mi) : void 0,
    elapsedTime: t(e, "elapsed_time") ? e.elapsed_time : void 0,
    adminIndex: t(e, "admin_index") ? e.admin_index : void 0,
    type: t(e, "type") ? M(e.type) : void 0,
    fork: t(e, "fork") ? e.fork : void 0,
    timeZone: t(e, "time_zone") ? e.time_zone : void 0
  };
}
function wi(e) {
  if (e !== void 0) return e === null ? null : {
    intersecting_edges: e.intersectingEdges === void 0 ? void 0 : e.intersectingEdges.map(vi),
    elapsed_time: e.elapsedTime,
    admin_index: e.adminIndex,
    type: e.type,
    fork: e.fork,
    time_zone: e.timeZone
  };
}
function io(e) {
  return !0;
}
function Ni(e) {
  return Ri(e);
}
function Ri(e, i) {
  return e == null ? e : {
    curvature: t(e, "curvature") ? e.curvature : void 0,
    maxDownSlope: t(e, "max_down_slope") ? e.max_down_slope : void 0,
    maxUpSlope: t(e, "max_up_slope") ? e.max_up_slope : void 0,
    weightedGrade: t(e, "weighted_grade") ? e.weighted_grade : void 0,
    length: t(e, "length") ? e.length : void 0
  };
}
function Ji(e) {
  if (e !== void 0) return e === null ? null : {
    curvature: e.curvature,
    max_down_slope: e.maxDownSlope,
    max_up_slope: e.maxUpSlope,
    weighted_grade: e.weightedGrade,
    length: e.length
  };
}
var to = {
  Point: "Point",
  MultiPoint: "MultiPoint",
  LineString: "LineString",
  MultiLineString: "MultiLineString",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon"
};
function no(e) {
  var i = !0;
  return i = i && "type" in e, i = i && "coordinates" in e, i;
}
function ro(e) {
  return Q(e);
}
function Q(e, i) {
  return e == null ? e : {
    type: e.type,
    coordinates: e.coordinates
  };
}
function Ci(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type,
    coordinates: e.coordinates
  };
}
var oo = {
  Point: "Point",
  MultiPoint: "MultiPoint",
  LineString: "LineString",
  MultiLineString: "MultiLineString",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon"
};
function co(e) {
  var i = !0;
  return i = i && "type" in e, i = i && "coordinates" in e, i;
}
function Fi(e) {
  return Y(e);
}
function Y(e, i) {
  return e == null ? e : {
    type: e.type,
    coordinates: e.coordinates
  };
}
function q(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type,
    coordinates: e.coordinates
  };
}
var ao = {
  Point: "Point",
  MultiPoint: "MultiPoint",
  LineString: "LineString",
  MultiLineString: "MultiLineString",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon"
};
function so(e) {
  var i = !0;
  return i = i && "type" in e, i = i && "coordinates" in e, i;
}
function uo(e) {
  return j(e);
}
function j(e, i) {
  return e == null ? e : {
    type: e.type,
    coordinates: e.coordinates
  };
}
function xi(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type,
    coordinates: e.coordinates
  };
}
function lo(e) {
  return ki(e);
}
function ki(e, i) {
  if (e == null) return e;
  switch (e.type) {
    case "LineString":
      return _objectSpread({}, Q(e), {
        type: "LineString"
      });
    case "Point":
      return _objectSpread({}, Y(e), {
        type: "Point"
      });
    case "Polygon":
      return _objectSpread({}, j(e), {
        type: "Polygon"
      });
    default:
      throw new Error("No variant of GeoJSONGeometry exists with 'type=".concat(e.type, "'"));
  }
}
function go(e) {
  if (e !== void 0) {
    if (e === null) return null;
    switch (e.type) {
      case "LineString":
        return Ci(e);
      case "Point":
        return q(e);
      case "Polygon":
        return xi(e);
      default:
        throw new Error("No variant of GeoJSONGeometry exists with 'type=".concat(e.type, "'"));
    }
  }
}
var po = {
  Point: "Point",
  MultiPoint: "MultiPoint",
  LineString: "LineString",
  MultiLineString: "MultiLineString",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon"
};
function _o(e) {
  var i = !0;
  return i = i && "type" in e, i;
}
function fo(e) {
  return Ii(e);
}
function Ii(e, i) {
  return e == null ? e : {
    type: e.type
  };
}
function yo(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type
  };
}
function ho(e) {
  var i = !0;
  return i = i && "coordinates" in e, i;
}
function mo(e) {
  return Mi(e);
}
function Mi(e, i) {
  return e == null ? e : {
    coordinates: e.coordinates
  };
}
function Oo(e) {
  if (e !== void 0) return e === null ? null : {
    coordinates: e.coordinates
  };
}
function vo(e) {
  var i = !0;
  return i = i && "coordinates" in e, i;
}
function So(e) {
  return Ei(e);
}
function Ei(e, i) {
  return e == null ? e : {
    coordinates: e.coordinates
  };
}
function bo(e) {
  if (e !== void 0) return e === null ? null : {
    coordinates: e.coordinates
  };
}
function To(e) {
  var i = !0;
  return i = i && "coordinates" in e, i;
}
function wo(e) {
  return Ai(e);
}
function Ai(e, i) {
  return e == null ? e : {
    coordinates: e.coordinates
  };
}
function No(e) {
  if (e !== void 0) return e === null ? null : {
    coordinates: e.coordinates
  };
}
function Ro(e) {
  return !0;
}
function Jo(e) {
  return Li(e);
}
function Li(e, i) {
  return e == null ? e : {
    attribution: t(e, "attribution") ? e.attribution : void 0,
    query: t(e, "query") ? e.query : void 0,
    warnings: t(e, "warnings") ? e.warnings : void 0,
    errors: t(e, "errors") ? e.errors : void 0
  };
}
function Co(e) {
  if (e !== void 0) return e === null ? null : {
    attribution: e.attribution,
    query: e.query,
    warnings: e.warnings,
    errors: e.errors
  };
}
var Fo = {
  Polyline6: "polyline6",
  Polyline5: "polyline5"
};
function xo(e) {
  return !0;
}
function ko(e) {
  return Pi(e);
}
function Pi(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    shape: t(e, "shape") ? e.shape.map(p) : void 0,
    encodedPolyline: t(e, "encoded_polyline") ? e.encoded_polyline : void 0,
    shapeFormat: t(e, "shape_format") ? e.shape_format : void 0,
    range: t(e, "range") ? e.range : void 0,
    heightPrecision: t(e, "height_precision") ? e.height_precision : void 0
  };
}
function Di(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    shape: e.shape === void 0 ? void 0 : e.shape.map(_),
    encoded_polyline: e.encodedPolyline,
    shape_format: e.shapeFormat,
    range: e.range,
    height_precision: e.heightPrecision
  };
}
function Io(e) {
  return !0;
}
function Bi(e) {
  return Gi(e);
}
function Gi(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    shape: t(e, "shape") ? e.shape.map(p) : void 0,
    encodedPolyline: t(e, "encoded_polyline") ? e.encoded_polyline : void 0,
    height: t(e, "height") ? e.height : void 0,
    rangeHeight: t(e, "range_height") ? e.range_height : void 0
  };
}
function Mo(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    shape: e.shape === void 0 ? void 0 : e.shape.map(_),
    encoded_polyline: e.encodedPolyline,
    height: e.height,
    range_height: e.rangeHeight
  };
}
var Eo = {
    PavedSmooth: "paved_smooth",
    Paved: "paved",
    PavedRough: "paved_rough",
    Compacted: "compacted",
    Dirt: "dirt",
    Gravel: "gravel",
    Path: "path",
    Impassable: "impassable"
  },
  Ao = {
    Road: "road",
    Ramp: "ramp",
    TurnChannel: "turn_channel",
    Track: "track",
    Driveway: "driveway",
    Alley: "alley",
    ParkingAisle: "parking_aisle",
    EmergencyAccess: "emergency_access",
    DriveThrough: "drive_through",
    Culdesac: "culdesac",
    LivingStreet: "living_street",
    ServiceRoad: "service_road",
    Cycleway: "cycleway",
    MountainBike: "mountain_bike",
    Sidewalk: "sidewalk",
    Footway: "footway",
    Elevator: "elevator",
    Steps: "steps",
    Escalator: "escalator",
    Path: "path",
    Pedestrian: "pedestrian",
    Bridleway: "bridleway",
    PedestrianCrossing: "pedestrian_crossing",
    RestArea: "rest_area",
    ServiceArea: "service_area",
    Other: "other",
    Rail: "rail",
    Ferry: "ferry",
    RailFerry: "rail-ferry",
    Bus: "bus",
    EgressConnection: "egress_connection",
    PlatformConnnection: "platform_connnection",
    TransitConnection: "transit_connection",
    Construction: "construction"
  },
  Lo = {
    Motorway: "motorway",
    Trunk: "trunk",
    Primary: "primary",
    Secondary: "secondary",
    Tertiary: "tertiary",
    Unclassified: "unclassified",
    Residential: "residential",
    ServiceOther: "service_other"
  };
function Po(e) {
  return !0;
}
function Hi(e) {
  return Wi(e);
}
function Wi(e, i) {
  return e == null ? e : {
    internal: t(e, "internal") ? e.internal : void 0,
    link: t(e, "link") ? e.link : void 0,
    surface: t(e, "surface") ? e.surface : void 0,
    use: t(e, "use") ? e.use : void 0,
    classification: t(e, "classification") ? e.classification : void 0
  };
}
function zi(e) {
  if (e !== void 0) return e === null ? null : {
    internal: e.internal,
    link: e.link,
    surface: e.surface,
    use: e.use,
    classification: e.classification
  };
}
var Do = {
  Auto: "auto",
  Bicycle: "bicycle",
  Pedestrian: "pedestrian"
};
function Ui(e) {
  return Ki(e);
}
function Ki(e, i) {
  return e;
}
function Bo(e) {
  return e;
}
var Go = {
  Time: "time",
  Distance: "distance"
};
function Ho(e) {
  return !0;
}
function Vi(e) {
  return $i(e);
}
function $i(e, i) {
  return e == null ? e : {
    fillColor: t(e, "fillColor") ? e.fillColor : void 0,
    opacity: t(e, "opacity") ? e.opacity : void 0,
    fill: t(e, "fill") ? e.fill : void 0,
    fillOpacity: t(e, "fillOpacity") ? e.fillOpacity : void 0,
    color: t(e, "color") ? e.color : void 0,
    contour: t(e, "contour") ? e.contour : void 0,
    metric: t(e, "metric") ? e.metric : void 0
  };
}
function Zi(e) {
  if (e !== void 0) return e === null ? null : {
    fillColor: e.fillColor,
    opacity: e.opacity,
    fill: e.fill,
    fillOpacity: e.fillOpacity,
    color: e.color,
    contour: e.contour,
    metric: e.metric
  };
}
var Wo = {
  Feature: "Feature"
};
function zo(e) {
  return !0;
}
function Xi(e) {
  return Qi(e);
}
function Qi(e, i) {
  return e == null ? e : {
    properties: t(e, "properties") ? Vi(e.properties) : void 0,
    geometry: t(e, "geometry") ? e.geometry : void 0,
    type: t(e, "type") ? e.type : void 0
  };
}
function Yi(e) {
  if (e !== void 0) return e === null ? null : {
    properties: Zi(e.properties),
    geometry: e.geometry,
    type: e.type
  };
}
function Uo(e) {
  var i = !0;
  return i = i && "locations" in e, i = i && "costing" in e, i = i && "contours" in e, i;
}
function Ko(e) {
  return qi(e);
}
function qi(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    locations: e.locations.map(p),
    costing: Ui(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    contours: e.contours.map(ai),
    polygons: t(e, "polygons") ? e.polygons : void 0,
    denoise: t(e, "denoise") ? e.denoise : void 0,
    generalize: t(e, "generalize") ? e.generalize : void 0,
    showLocations: t(e, "show_locations") ? e.show_locations : void 0
  };
}
function ji(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    locations: e.locations.map(_),
    costing: e.costing,
    costing_options: l(e.costingOptions),
    contours: e.contours.map(si),
    polygons: e.polygons,
    denoise: e.denoise,
    generalize: e.generalize,
    show_locations: e.showLocations
  };
}
var Vo = {
  FeatureCollection: "FeatureCollection"
};
function $o(e) {
  var i = !0;
  return i = i && "features" in e, i = i && "type" in e, i;
}
function et(e) {
  return it(e);
}
function it(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    features: e.features.map(Xi),
    type: e.type
  };
}
function Zo(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    features: e.features.map(Yi),
    type: e.type
  };
}
function Xo(e) {
  return !0;
}
function T(e) {
  return tt(e);
}
function tt(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    value: t(e, "value") ? e.value : void 0,
    tileId: t(e, "tile_id") ? e.tile_id : void 0,
    level: t(e, "level") ? e.level : void 0
  };
}
function w(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    value: e.value,
    tile_id: e.tileId,
    level: e.level
  };
}
function Qo(e) {
  return !0;
}
function C(e) {
  return nt(e);
}
function nt(e, i) {
  return e == null ? e : {
    golfCart: t(e, "golf_cart") ? e.golf_cart : void 0,
    truck: t(e, "truck") ? e.truck : void 0,
    pedestrian: t(e, "pedestrian") ? e.pedestrian : void 0,
    wheelchair: t(e, "wheelchair") ? e.wheelchair : void 0,
    taxi: t(e, "taxi") ? e.taxi : void 0,
    hOV: t(e, "HOV") ? e.HOV : void 0,
    emergency: t(e, "emergency") ? e.emergency : void 0,
    motorcycle: t(e, "motorcycle") ? e.motorcycle : void 0,
    car: t(e, "car") ? e.car : void 0,
    moped: t(e, "moped") ? e.moped : void 0,
    bus: t(e, "bus") ? e.bus : void 0,
    bicycle: t(e, "bicycle") ? e.bicycle : void 0
  };
}
function F(e) {
  if (e !== void 0) return e === null ? null : {
    golf_cart: e.golfCart,
    truck: e.truck,
    pedestrian: e.pedestrian,
    wheelchair: e.wheelchair,
    taxi: e.taxi,
    HOV: e.hOV,
    emergency: e.emergency,
    motorcycle: e.motorcycle,
    car: e.car,
    moped: e.moped,
    bus: e.bus,
    bicycle: e.bicycle
  };
}
var Yo = {
  Classified: "classified",
  Tagged: "tagged"
};
function qo(e) {
  return !0;
}
function rt(e) {
  return ot(e);
}
function ot(e, i) {
  return e == null ? e : {
    predicted: t(e, "predicted") ? e.predicted : void 0,
    constrainedFlow: t(e, "constrained_flow") ? e.constrained_flow : void 0,
    freeFlow: t(e, "free_flow") ? e.free_flow : void 0,
    type: t(e, "type") ? e.type : void 0,
    _default: t(e, "default") ? e.default : void 0
  };
}
function ct(e) {
  if (e !== void 0) return e === null ? null : {
    predicted: e.predicted,
    constrained_flow: e.constrainedFlow,
    free_flow: e.freeFlow,
    type: e.type,
    default: e._default
  };
}
var jo = {
    None: "none",
    Hiking: "hiking",
    MountainHiking: "mountain hiking",
    DemandingMountainHiking: "demanding mountain hiking",
    AlpineHiking: "alpine hiking",
    DemandingAlpineHiking: "demanding alpine hiking",
    DifficultAlpineHiking: "difficult alpine hiking"
  },
  ec = {
    None: "none",
    Shared: "shared",
    Dedicated: "dedicated",
    Separated: "separated"
  };
function ic(e) {
  return !0;
}
function at(e) {
  return dt(e);
}
function dt(e, i) {
  return e == null ? e : {
    sidewalkLeft: t(e, "sidewalk_left") ? e.sidewalk_left : void 0,
    sidewalkRight: t(e, "sidewalk_right") ? e.sidewalk_right : void 0,
    laneCount: t(e, "lane_count") ? e.lane_count : void 0,
    stopSign: t(e, "stop_sign") ? e.stop_sign : void 0,
    sacScale: t(e, "sac_scale") ? e.sac_scale : void 0,
    yieldSign: t(e, "yield_sign") ? e.yield_sign : void 0,
    notThru: t(e, "not_thru") ? e.not_thru : void 0,
    forward: t(e, "forward") ? e.forward : void 0,
    endNode: t(e, "end_node") ? T(e.end_node) : void 0,
    truckRoute: t(e, "truck_route") ? e.truck_route : void 0,
    speeds: t(e, "speeds") ? rt(e.speeds) : void 0,
    bikeNetwork: t(e, "bike_network") ? e.bike_network : void 0,
    roundAbout: t(e, "round_about") ? e.round_about : void 0,
    trafficSignal: t(e, "traffic_signal") ? e.traffic_signal : void 0,
    accessRestriction: t(e, "access_restriction") ? e.access_restriction : void 0,
    destinationOnly: t(e, "destination_only") ? e.destination_only : void 0,
    geoAttributes: t(e, "geo_attributes") ? Ni(e.geo_attributes) : void 0,
    startRestriction: t(e, "start_restriction") ? C(e.start_restriction) : void 0,
    cycleLane: t(e, "cycle_lane") ? e.cycle_lane : void 0,
    endRestriction: t(e, "end_restriction") ? C(e.end_restriction) : void 0,
    seasonal: t(e, "seasonal") ? e.seasonal : void 0,
    countryCrossing: t(e, "country_crossing") ? e.country_crossing : void 0,
    partOfComplexRestriction: t(e, "part_of_complex_restriction") ? e.part_of_complex_restriction : void 0,
    hasSign: t(e, "has_sign") ? e.has_sign : void 0,
    access: t(e, "access") ? C(e.access) : void 0,
    bridge: t(e, "bridge") ? e.bridge : void 0,
    classification: t(e, "classification") ? Hi(e.classification) : void 0,
    toll: t(e, "toll") ? e.toll : void 0,
    tunnel: t(e, "tunnel") ? e.tunnel : void 0
  };
}
function st(e) {
  if (e !== void 0) return e === null ? null : {
    sidewalk_left: e.sidewalkLeft,
    sidewalk_right: e.sidewalkRight,
    lane_count: e.laneCount,
    stop_sign: e.stopSign,
    sac_scale: e.sacScale,
    yield_sign: e.yieldSign,
    not_thru: e.notThru,
    forward: e.forward,
    end_node: w(e.endNode),
    truck_route: e.truckRoute,
    speeds: ct(e.speeds),
    bike_network: e.bikeNetwork,
    round_about: e.roundAbout,
    traffic_signal: e.trafficSignal,
    access_restriction: e.accessRestriction,
    destination_only: e.destinationOnly,
    geo_attributes: Ji(e.geoAttributes),
    start_restriction: F(e.startRestriction),
    cycle_lane: e.cycleLane,
    end_restriction: F(e.endRestriction),
    seasonal: e.seasonal,
    country_crossing: e.countryCrossing,
    part_of_complex_restriction: e.partOfComplexRestriction,
    has_sign: e.hasSign,
    access: F(e.access),
    bridge: e.bridge,
    classification: zi(e.classification),
    toll: e.toll,
    tunnel: e.tunnel
  };
}
function tc(e) {
  return !0;
}
function ut(e) {
  return lt(e);
}
function lt(e, i) {
  return e == null ? e : {
    meanElevation: t(e, "mean_elevation") ? e.mean_elevation : void 0,
    shape: t(e, "shape") ? e.shape : void 0,
    names: t(e, "names") ? e.names : void 0,
    bikeNetwork: t(e, "bike_network") ? ri(e.bike_network) : void 0,
    wayId: t(e, "way_id") ? e.way_id : void 0
  };
}
function gt(e) {
  if (e !== void 0) return e === null ? null : {
    mean_elevation: e.meanElevation,
    shape: e.shape,
    names: e.names,
    bike_network: ci(e.bikeNetwork),
    way_id: e.wayId
  };
}
var nc = {
  Left: "left",
  Right: "right",
  Neither: "neither"
};
function rc(e) {
  return !0;
}
function pt(e) {
  return _t(e);
}
function _t(e, i) {
  return e == null ? e : {
    edgeId: t(e, "edge_id") ? T(e.edge_id) : void 0,
    correlatedLat: t(e, "correlated_lat") ? e.correlated_lat : void 0,
    correlatedLon: t(e, "correlated_lon") ? e.correlated_lon : void 0,
    percentAlong: t(e, "percent_along") ? e.percent_along : void 0,
    sideOfStreet: t(e, "side_of_street") ? e.side_of_street : void 0,
    linearReference: t(e, "linear_reference") ? e.linear_reference : void 0,
    outboundReach: t(e, "outbound_reach") ? e.outbound_reach : void 0,
    heading: t(e, "heading") ? e.heading : void 0,
    inboundReach: t(e, "inbound_reach") ? e.inbound_reach : void 0,
    distance: t(e, "distance") ? e.distance : void 0,
    predictedSpeeds: t(e, "predicted_speeds") ? e.predicted_speeds : void 0,
    edgeInfo: t(e, "edge_info") ? ut(e.edge_info) : void 0,
    edge: t(e, "edge") ? at(e.edge) : void 0,
    warnings: t(e, "warnings") ? e.warnings : void 0
  };
}
function ft(e) {
  if (e !== void 0) return e === null ? null : {
    edge_id: w(e.edgeId),
    correlated_lat: e.correlatedLat,
    correlated_lon: e.correlatedLon,
    percent_along: e.percentAlong,
    side_of_street: e.sideOfStreet,
    linear_reference: e.linearReference,
    outbound_reach: e.outboundReach,
    heading: e.heading,
    inbound_reach: e.inboundReach,
    distance: e.distance,
    predicted_speeds: e.predictedSpeeds,
    edge_info: gt(e.edgeInfo),
    edge: st(e.edge),
    warnings: e.warnings
  };
}
var oc = {
  Regular: "regular",
  False: "false",
  DeadEnd: "dead-end",
  Fork: "fork"
};
function cc(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function yt(e) {
  return ht(e);
}
function ht(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    trafficSignal: t(e, "traffic_signal") ? e.traffic_signal : void 0,
    type: t(e, "type") ? M(e.type) : void 0,
    nodeId: t(e, "node_id") ? T(e.node_id) : void 0,
    access: t(e, "access") ? H(e.access) : void 0,
    edgeCount: t(e, "edge_count") ? e.edge_count : void 0,
    administrative: t(e, "administrative") ? K(e.administrative) : void 0,
    intersectionType: t(e, "intersection_type") ? e.intersection_type : void 0,
    density: t(e, "density") ? e.density : void 0,
    localEdgeCount: t(e, "local_edge_count") ? e.local_edge_count : void 0,
    modeChange: t(e, "mode_change") ? e.mode_change : void 0
  };
}
function mt(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    traffic_signal: e.trafficSignal,
    type: e.type,
    node_id: w(e.nodeId),
    access: W(e.access),
    edge_count: e.edgeCount,
    administrative: V(e.administrative),
    intersection_type: e.intersectionType,
    density: e.density,
    local_edge_count: e.localEdgeCount,
    mode_change: e.modeChange
  };
}
var ac = {
  Regular: "regular",
  False: "false",
  DeadEnd: "dead-end",
  Fork: "fork"
};
function dc(e) {
  return !0;
}
function sc(e) {
  return Ot(e);
}
function Ot(e, i) {
  return e == null ? e : {
    trafficSignal: t(e, "traffic_signal") ? e.traffic_signal : void 0,
    type: t(e, "type") ? M(e.type) : void 0,
    nodeId: t(e, "node_id") ? T(e.node_id) : void 0,
    access: t(e, "access") ? H(e.access) : void 0,
    edgeCount: t(e, "edge_count") ? e.edge_count : void 0,
    administrative: t(e, "administrative") ? K(e.administrative) : void 0,
    intersectionType: t(e, "intersection_type") ? e.intersection_type : void 0,
    density: t(e, "density") ? e.density : void 0,
    localEdgeCount: t(e, "local_edge_count") ? e.local_edge_count : void 0,
    modeChange: t(e, "mode_change") ? e.mode_change : void 0
  };
}
function uc(e) {
  if (e !== void 0) return e === null ? null : {
    traffic_signal: e.trafficSignal,
    type: e.type,
    node_id: w(e.nodeId),
    access: W(e.access),
    edge_count: e.edgeCount,
    administrative: V(e.administrative),
    intersection_type: e.intersectionType,
    density: e.density,
    local_edge_count: e.localEdgeCount,
    mode_change: e.modeChange
  };
}
function lc(e) {
  return !0;
}
function vt(e) {
  return St(e);
}
function St(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    inputLat: t(e, "input_lat") ? e.input_lat : void 0,
    inputLon: t(e, "input_lon") ? e.input_lon : void 0,
    nodes: t(e, "nodes") ? e.nodes.map(yt) : void 0,
    edges: t(e, "edges") ? e.edges.map(pt) : void 0
  };
}
function gc(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    input_lat: e.inputLat,
    input_lon: e.inputLon,
    nodes: e.nodes === void 0 ? void 0 : e.nodes.map(mt),
    edges: e.edges === void 0 ? void 0 : e.edges.map(ft)
  };
}
function pc(e) {
  var i = !0;
  return i = i && "text" in e, i;
}
function m(e) {
  return bt(e);
}
function bt(e, i) {
  return e == null ? e : {
    text: e.text,
    isRouteNumber: t(e, "is_route_number") ? e.is_route_number : void 0,
    consecutiveCount: t(e, "consecutive_count") ? e.consecutive_count : void 0
  };
}
function O(e) {
  if (e !== void 0) return e === null ? null : {
    text: e.text,
    is_route_number: e.isRouteNumber,
    consecutive_count: e.consecutiveCount
  };
}
function _c(e) {
  return !0;
}
function Tt(e) {
  return wt(e);
}
function wt(e, i) {
  return e == null ? e : {
    exitNumberElements: t(e, "exit_number_elements") ? e.exit_number_elements.map(m) : void 0,
    exitBranchElements: t(e, "exit_branch_elements") ? e.exit_branch_elements.map(m) : void 0,
    exitTowardElements: t(e, "exit_toward_elements") ? e.exit_toward_elements.map(m) : void 0,
    exitNameElements: t(e, "exit_name_elements") ? e.exit_name_elements.map(m) : void 0
  };
}
function Nt(e) {
  if (e !== void 0) return e === null ? null : {
    exit_number_elements: e.exitNumberElements === void 0 ? void 0 : e.exitNumberElements.map(O),
    exit_branch_elements: e.exitBranchElements === void 0 ? void 0 : e.exitBranchElements.map(O),
    exit_toward_elements: e.exitTowardElements === void 0 ? void 0 : e.exitTowardElements.map(O),
    exit_name_elements: e.exitNameElements === void 0 ? void 0 : e.exitNameElements.map(O)
  };
}
function fc(e) {
  return !0;
}
function ee(e) {
  return Rt(e);
}
function Rt(e, i) {
  return e == null ? e : {
    searchRadius: t(e, "search_radius") ? e.search_radius : void 0,
    gpsAccuracy: t(e, "gps_accuracy") ? e.gps_accuracy : void 0,
    breakageDistance: t(e, "breakage_distance") ? e.breakage_distance : void 0,
    interpolationDistance: t(e, "interpolation_distance") ? e.interpolation_distance : void 0,
    turnPenaltyFactor: t(e, "turn_penalty_factor") ? e.turn_penalty_factor : void 0
  };
}
function ie(e) {
  if (e !== void 0) return e === null ? null : {
    search_radius: e.searchRadius,
    gps_accuracy: e.gpsAccuracy,
    breakage_distance: e.breakageDistance,
    interpolation_distance: e.interpolationDistance,
    turn_penalty_factor: e.turnPenaltyFactor
  };
}
var yc = {
  EdgeWalk: "edge_walk",
  MapSnap: "map_snap",
  WalkOrSnap: "walk_or_snap"
};
function hc(e) {
  var i = !0;
  return i = i && "costing" in e, i;
}
function mc(e) {
  return Jt(e);
}
function Jt(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    shape: t(e, "shape") ? e.shape.map(k) : void 0,
    encodedPolyline: t(e, "encoded_polyline") ? e.encoded_polyline : void 0,
    costing: x(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    shapeMatch: t(e, "shape_match") ? e.shape_match : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0,
    beginTime: t(e, "begin_time") ? e.begin_time : void 0,
    durations: t(e, "durations") ? e.durations : void 0,
    useTimestamps: t(e, "use_timestamps") ? e.use_timestamps : void 0,
    traceOptions: t(e, "trace_options") ? ee(e.trace_options) : void 0,
    linearReferences: t(e, "linear_references") ? e.linear_references : void 0
  };
}
function Ct(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    shape: e.shape === void 0 ? void 0 : e.shape.map(I),
    encoded_polyline: e.encodedPolyline,
    costing: e.costing,
    costing_options: l(e.costingOptions),
    shape_match: e.shapeMatch,
    directions_options: y(e.directionsOptions),
    begin_time: e.beginTime,
    durations: e.durations,
    use_timestamps: e.useTimestamps,
    trace_options: ie(e.traceOptions),
    linear_references: e.linearReferences
  };
}
function Oc(e) {
  return !0;
}
function vc(e) {
  return Ft(e);
}
function Ft(e, i) {
  return e == null ? e : {
    beginTime: t(e, "begin_time") ? e.begin_time : void 0,
    durations: t(e, "durations") ? e.durations : void 0,
    useTimestamps: t(e, "use_timestamps") ? e.use_timestamps : void 0,
    traceOptions: t(e, "trace_options") ? ee(e.trace_options) : void 0,
    linearReferences: t(e, "linear_references") ? e.linear_references : void 0
  };
}
function Sc(e) {
  if (e !== void 0) return e === null ? null : {
    begin_time: e.beginTime,
    durations: e.durations,
    use_timestamps: e.useTimestamps,
    trace_options: ie(e.traceOptions),
    linear_references: e.linearReferences
  };
}
var bc = {
  Drive: "drive",
  Pedestrian: "pedestrian",
  Bicycle: "bicycle",
  Transit: "transit"
};
function te(e) {
  return xt(e);
}
function xt(e, i) {
  return e;
}
function Tc(e) {
  return e;
}
var wc = {
    Car: "car",
    Foot: "foot",
    Road: "road",
    Tram: "tram",
    Metro: "metro",
    Rail: "rail",
    Bus: "bus",
    Ferry: "ferry",
    CableCar: "cable_car",
    Gondola: "gondola",
    Funicular: "funicular"
  },
  Nc = {
    NoneAction: "NoneAction",
    RentBikeAtBikeShare: "RentBikeAtBikeShare",
    ReturnBikeAtBikeShare: "ReturnBikeAtBikeShare"
  };
function Rc(e) {
  var i = !0;
  return i = i && "type" in e, i = i && "instruction" in e, i = i && "time" in e, i = i && "length" in e, i = i && "beginShapeIndex" in e, i = i && "endShapeIndex" in e, i = i && "travelMode" in e, i = i && "travelType" in e, i;
}
function kt(e) {
  return It(e);
}
function It(e, i) {
  return e == null ? e : {
    type: e.type,
    instruction: e.instruction,
    verbalTransitionAlertInstruction: t(e, "verbal_transition_alert_instruction") ? e.verbal_transition_alert_instruction : void 0,
    verbalPreTransitionInstruction: t(e, "verbal_pre_transition_instruction") ? e.verbal_pre_transition_instruction : void 0,
    verbalPostTransitionInstruction: t(e, "verbal_post_transition_instruction") ? e.verbal_post_transition_instruction : void 0,
    streetNames: t(e, "street_names") ? e.street_names : void 0,
    beginStreetNames: t(e, "begin_street_names") ? e.begin_street_names : void 0,
    time: e.time,
    length: e.length,
    beginShapeIndex: e.begin_shape_index,
    endShapeIndex: e.end_shape_index,
    toll: t(e, "toll") ? e.toll : void 0,
    rough: t(e, "rough") ? e.rough : void 0,
    gate: t(e, "gate") ? e.gate : void 0,
    ferry: t(e, "ferry") ? e.ferry : void 0,
    sign: t(e, "sign") ? Tt(e.sign) : void 0,
    roundaboutExitCount: t(e, "roundabout_exit_count") ? e.roundabout_exit_count : void 0,
    departInstruction: t(e, "depart_instruction") ? e.depart_instruction : void 0,
    verbalDepartInstruction: t(e, "verbal_depart_instruction") ? e.verbal_depart_instruction : void 0,
    arriveInstruction: t(e, "arrive_instruction") ? e.arrive_instruction : void 0,
    verbalArriveInstruction: t(e, "verbal_arrive_instruction") ? e.verbal_arrive_instruction : void 0,
    transitInfo: t(e, "transit_info") ? e.transit_info : void 0,
    verbalMultiCue: t(e, "verbal_multi_cue") ? e.verbal_multi_cue : void 0,
    travelMode: te(e.travel_mode),
    travelType: e.travel_type,
    bssManeuverType: t(e, "bss_maneuver_type") ? e.bss_maneuver_type : void 0
  };
}
function Mt(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type,
    instruction: e.instruction,
    verbal_transition_alert_instruction: e.verbalTransitionAlertInstruction,
    verbal_pre_transition_instruction: e.verbalPreTransitionInstruction,
    verbal_post_transition_instruction: e.verbalPostTransitionInstruction,
    street_names: e.streetNames,
    begin_street_names: e.beginStreetNames,
    time: e.time,
    length: e.length,
    begin_shape_index: e.beginShapeIndex,
    end_shape_index: e.endShapeIndex,
    toll: e.toll,
    rough: e.rough,
    gate: e.gate,
    ferry: e.ferry,
    sign: Nt(e.sign),
    roundabout_exit_count: e.roundaboutExitCount,
    depart_instruction: e.departInstruction,
    verbal_depart_instruction: e.verbalDepartInstruction,
    arrive_instruction: e.arriveInstruction,
    verbal_arrive_instruction: e.verbalArriveInstruction,
    transit_info: e.transitInfo,
    verbal_multi_cue: e.verbalMultiCue,
    travel_mode: e.travelMode,
    travel_type: e.travelType,
    bss_maneuver_type: e.bssManeuverType
  };
}
function Jc(e) {
  var i = !0;
  return i = i && "time" in e, i = i && "length" in e, i = i && "minLat" in e, i = i && "maxLat" in e, i = i && "minLon" in e, i = i && "maxLon" in e, i;
}
function ne(e) {
  return Et(e);
}
function Et(e, i) {
  return e == null ? e : {
    time: e.time,
    length: e.length,
    minLat: e.min_lat,
    maxLat: e.max_lat,
    minLon: e.min_lon,
    maxLon: e.max_lon
  };
}
function re(e) {
  if (e !== void 0) return e === null ? null : {
    time: e.time,
    length: e.length,
    min_lat: e.minLat,
    max_lat: e.maxLat,
    min_lon: e.minLon,
    max_lon: e.maxLon
  };
}
function Cc(e) {
  var i = !0;
  return i = i && "maneuvers" in e, i = i && "shape" in e, i = i && "summary" in e, i;
}
function At(e) {
  return Lt(e);
}
function Lt(e, i) {
  return e == null ? e : {
    maneuvers: e.maneuvers.map(kt),
    shape: e.shape,
    summary: ne(e.summary)
  };
}
function Pt(e) {
  if (e !== void 0) return e === null ? null : {
    maneuvers: e.maneuvers.map(Mt),
    shape: e.shape,
    summary: re(e.summary)
  };
}
var Fc = {
  Break: "break",
  Through: "through",
  Via: "via",
  BreakThrough: "break_through"
};
function xc(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function Dt(e) {
  return Bt(e);
}
function Bt(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    type: t(e, "type") ? e.type : void 0,
    originalIndex: t(e, "original_index") ? e.original_index : void 0
  };
}
function Gt(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    type: e.type,
    original_index: e.originalIndex
  };
}
var kc = {
  Miles: "miles",
  Kilometers: "kilometers"
};
function N(e) {
  return Ht(e);
}
function Ht(e, i) {
  return e;
}
function Ic(e) {
  return e;
}
function Mc(e) {
  var i = !0;
  return i = i && "status" in e, i = i && "statusMessage" in e, i = i && "units" in e, i = i && "language" in e, i = i && "locations" in e, i = i && "legs" in e, i = i && "summary" in e, i;
}
function oe(e) {
  return Wt(e);
}
function Wt(e, i) {
  return e == null ? e : {
    status: e.status,
    statusMessage: e.status_message,
    units: N(e.units),
    language: $(e.language),
    locations: e.locations.map(Dt),
    legs: e.legs.map(At),
    summary: ne(e.summary)
  };
}
function ce(e) {
  if (e !== void 0) return e === null ? null : {
    status: e.status,
    status_message: e.statusMessage,
    units: e.units,
    language: e.language,
    locations: e.locations.map(Gt),
    legs: e.legs.map(Pt),
    summary: re(e.summary)
  };
}
function Ec(e) {
  var i = !0;
  return i = i && "trip" in e, i;
}
function zt(e) {
  return Ut(e);
}
function Ut(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    trip: oe(e.trip),
    linearReferences: t(e, "linear_references") ? e.linear_references : void 0
  };
}
function Ac(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    trip: ce(e.trip),
    linear_references: e.linearReferences
  };
}
function Lc(e) {
  return !0;
}
function Pc(e) {
  return Kt(e);
}
function Kt(e, i) {
  return e == null ? e : {
    linearReferences: t(e, "linear_references") ? e.linear_references : void 0
  };
}
function Dc(e) {
  if (e !== void 0) return e === null ? null : {
    linear_references: e.linearReferences
  };
}
function Bc(e) {
  return !0;
}
function Gc(e) {
  return Vt(e);
}
function Vt(e, i) {
  return e == null ? e : {
    time: t(e, "time") ? e.time : void 0
  };
}
function Hc(e) {
  if (e !== void 0) return e === null ? null : {
    time: e.time
  };
}
var Wc = {
  Unmatched: "unmatched",
  Interpolated: "interpolated",
  Matched: "matched"
};
function zc(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i = i && "type" in e, i;
}
function ae(e) {
  return $t(e);
}
function $t(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    type: e.type,
    edgeIndex: t(e, "edge_index") ? e.edge_index : void 0,
    beginRouteDiscontinuity: t(e, "begin_route_discontinuity") ? e.begin_route_discontinuity : void 0,
    endRouteDiscontinuity: t(e, "end_route_discontinuity") ? e.end_route_discontinuity : void 0,
    distanceAlongEdge: t(e, "distance_along_edge") ? e.distance_along_edge : void 0,
    distanceFromTracePoint: t(e, "distance_from_trace_point") ? e.distance_from_trace_point : void 0
  };
}
function de(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    type: e.type,
    edge_index: e.edgeIndex,
    begin_route_discontinuity: e.beginRouteDiscontinuity,
    end_route_discontinuity: e.endRouteDiscontinuity,
    distance_along_edge: e.distanceAlongEdge,
    distance_from_trace_point: e.distanceFromTracePoint
  };
}
var Uc = {
  Auto: "auto",
  Bus: "bus",
  Hov: "hov",
  Taxi: "taxi",
  Truck: "truck",
  Bicycle: "bicycle",
  Bikeshare: "bikeshare",
  MotorScooter: "motor_scooter",
  Motorcycle: "motorcycle",
  Pedestrian: "pedestrian"
};
function se(e) {
  return Zt(e);
}
function Zt(e, i) {
  return e;
}
function Kc(e) {
  return e;
}
function Vc(e) {
  var i = !0;
  return i = i && "distance" in e, i = i && "time" in e, i = i && "fromIndex" in e, i = i && "toIndex" in e, i;
}
function $c(e) {
  return Xt(e);
}
function Xt(e, i) {
  return e == null ? e : {
    distance: e.distance,
    time: e.time,
    fromIndex: e.from_index,
    toIndex: e.to_index
  };
}
function Zc(e) {
  if (e !== void 0) return e === null ? null : {
    distance: e.distance,
    time: e.time,
    from_index: e.fromIndex,
    to_index: e.toIndex
  };
}
function Xc(e) {
  var i = !0;
  return i = i && "sources" in e, i = i && "targets" in e, i = i && "costing" in e, i;
}
function Qc(e) {
  return Qt(e);
}
function Qt(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    sources: e.sources.map(p),
    targets: e.targets.map(p),
    costing: se(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    matrixLocations: t(e, "matrix_locations") ? e.matrix_locations : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0
  };
}
function Yt(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    sources: e.sources.map(_),
    targets: e.targets.map(_),
    costing: e.costing,
    costing_options: l(e.costingOptions),
    matrix_locations: e.matrixLocations,
    directions_options: y(e.directionsOptions)
  };
}
function Yc(e) {
  return !0;
}
function qt(e) {
  return jt(e);
}
function jt(e, i) {
  return e == null ? e : {
    text: t(e, "text") ? e.text : void 0,
    code: t(e, "code") ? e.code : void 0
  };
}
function en(e) {
  if (e !== void 0) return e === null ? null : {
    text: e.text,
    code: e.code
  };
}
function qc(e) {
  var i = !0;
  return i = i && "sources" in e, i = i && "targets" in e, i = i && "sourcesToTargets" in e, i = i && "units" in e, i;
}
function tn(e) {
  return nn(e);
}
function nn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    sources: e.sources,
    targets: e.targets,
    sourcesToTargets: e.sources_to_targets,
    warnings: t(e, "warnings") ? e.warnings.map(qt) : void 0,
    units: N(e.units)
  };
}
function jc(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    sources: e.sources,
    targets: e.targets,
    sources_to_targets: e.sourcesToTargets,
    warnings: e.warnings === void 0 ? void 0 : e.warnings.map(en),
    units: e.units
  };
}
function ea(e) {
  return !0;
}
function ia(e) {
  return rn(e);
}
function rn(e, i) {
  return e == null ? e : {
    usePrimary: t(e, "use_primary") ? e.use_primary : void 0,
    useHills: t(e, "use_hills") ? e.use_hills : void 0
  };
}
function ta(e) {
  if (e !== void 0) return e === null ? null : {
    use_primary: e.usePrimary,
    use_hills: e.useHills
  };
}
function na(e) {
  return !0;
}
function ra(e) {
  return on(e);
}
function on(e, i) {
  return e == null ? e : {
    useHighways: t(e, "use_highways") ? e.use_highways : void 0,
    useTrails: t(e, "use_trails") ? e.use_trails : void 0
  };
}
function oa(e) {
  if (e !== void 0) return e === null ? null : {
    use_highways: e.useHighways,
    use_trails: e.useTrails
  };
}
function ca(e) {
  var i = !0;
  return i = i && "locations" in e, i;
}
function aa(e) {
  return cn(e);
}
function cn(e, i) {
  return e == null ? e : {
    locations: e.locations.map(p),
    costing: t(e, "costing") ? Z(e.costing) : void 0,
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    verbose: t(e, "verbose") ? e.verbose : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0
  };
}
function an(e) {
  if (e !== void 0) return e === null ? null : {
    locations: e.locations.map(_),
    costing: e.costing,
    costing_options: l(e.costingOptions),
    verbose: e.verbose,
    directions_options: y(e.directionsOptions)
  };
}
function da(e) {
  var i = !0;
  return i = i && "locations" in e, i = i && "costing" in e, i;
}
function sa(e) {
  return dn(e);
}
function dn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    locations: e.locations.map(p),
    costing: se(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0
  };
}
function sn(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    locations: e.locations.map(_),
    costing: e.costing,
    costing_options: l(e.costingOptions),
    directions_options: y(e.directionsOptions)
  };
}
function ua(e) {
  return !0;
}
function un(e) {
  return ln(e);
}
function ln(e, i) {
  return e == null ? e : _objectSpread({}, e, {
    website: t(e, "website") ? e.website : void 0,
    wikipedia: t(e, "wikipedia") ? e.wikipedia : void 0,
    wikidata: t(e, "wikidata") ? e.wikidata : void 0,
    phone: t(e, "phone") ? e.phone : void 0
  });
}
function gn(e) {
  if (e !== void 0) return e === null ? null : _objectSpread({}, e, {
    website: e.website,
    wikipedia: e.wikipedia,
    wikidata: e.wikidata,
    phone: e.phone
  });
}
function la(e) {
  return !0;
}
function pn(e) {
  return _n(e);
}
function _n(e, i) {
  return e == null ? e : _objectSpread({}, e, {
    osm: t(e, "osm") ? un(e.osm) : void 0
  });
}
function fn(e) {
  if (e !== void 0) return e === null ? null : _objectSpread({}, e, {
    osm: gn(e.osm)
  });
}
var ga = {
  Venue: "venue",
  Address: "address",
  Street: "street",
  Country: "country",
  Macroregion: "macroregion",
  Region: "region",
  Macrocounty: "macrocounty",
  County: "county",
  Locality: "locality",
  Localadmin: "localadmin",
  Borough: "borough",
  Neighbourhood: "neighbourhood",
  Postalcode: "postalcode",
  Coarse: "coarse",
  Dependency: "dependency",
  Macrohood: "macrohood",
  Marinearea: "marinearea",
  Disputed: "disputed",
  Empire: "empire",
  Continent: "continent",
  Ocean: "ocean"
};
function yn(e) {
  return hn(e);
}
function hn(e, i) {
  return e;
}
function pa(e) {
  return e;
}
var _a = {
  Point: "point",
  Centroid: "centroid"
};
function fa(e) {
  return !0;
}
function mn(e) {
  return On(e);
}
function On(e, i) {
  return e == null ? e : _objectSpread({}, e, {
    gid: t(e, "gid") ? e.gid : void 0,
    sourceId: t(e, "source_id") ? e.source_id : void 0,
    label: t(e, "label") ? e.label : void 0,
    layer: t(e, "layer") ? yn(e.layer) : void 0,
    name: t(e, "name") ? e.name : void 0,
    accuracy: t(e, "accuracy") ? e.accuracy : void 0,
    addendum: t(e, "addendum") ? pn(e.addendum) : void 0,
    continent: t(e, "continent") ? e.continent : void 0,
    continentGid: t(e, "continent_gid") ? e.continent_gid : void 0,
    country: t(e, "country") ? e.country : void 0,
    countryGid: t(e, "country_gid") ? e.country_gid : void 0,
    neighbourhood: t(e, "neighbourhood") ? e.neighbourhood : void 0,
    neighbourhoodGid: t(e, "neighbourhood_gid") ? e.neighbourhood_gid : void 0,
    borough: t(e, "borough") ? e.borough : void 0,
    boroughGid: t(e, "borough_gid") ? e.borough_gid : void 0,
    postalcode: t(e, "postalcode") ? e.postalcode : void 0,
    street: t(e, "street") ? e.street : void 0,
    housenumber: t(e, "housenumber") ? e.housenumber : void 0,
    locality: t(e, "locality") ? e.locality : void 0,
    localityGid: t(e, "locality_gid") ? e.locality_gid : void 0,
    county: t(e, "county") ? e.county : void 0,
    region: t(e, "region") ? e.region : void 0,
    regionA: t(e, "region_a") ? e.region_a : void 0
  });
}
function vn(e) {
  if (e !== void 0) return e === null ? null : _objectSpread({}, e, {
    gid: e.gid,
    source_id: e.sourceId,
    label: e.label,
    layer: e.layer,
    name: e.name,
    accuracy: e.accuracy,
    addendum: fn(e.addendum),
    continent: e.continent,
    continent_gid: e.continentGid,
    country: e.country,
    country_gid: e.countryGid,
    neighbourhood: e.neighbourhood,
    neighbourhood_gid: e.neighbourhoodGid,
    borough: e.borough,
    borough_gid: e.boroughGid,
    postalcode: e.postalcode,
    street: e.street,
    housenumber: e.housenumber,
    locality: e.locality,
    locality_gid: e.localityGid,
    county: e.county,
    region: e.region,
    region_a: e.regionA
  });
}
var ya = {
  Feature: "Feature"
};
function ha(e) {
  var i = !0;
  return i = i && "type" in e, i = i && "geometry" in e, i;
}
function Sn(e) {
  return bn(e);
}
function bn(e, i) {
  return e == null ? e : {
    type: e.type,
    geometry: Fi(e.geometry),
    properties: t(e, "properties") ? mn(e.properties) : void 0,
    bbox: t(e, "bbox") ? e.bbox : void 0,
    id: t(e, "id") ? e.id : void 0
  };
}
function Tn(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type,
    geometry: q(e.geometry),
    properties: vn(e.properties),
    bbox: e.bbox,
    id: e.id
  };
}
function ma(e) {
  return !0;
}
function wn(e) {
  return Nn(e);
}
function Nn(e, i) {
  return e == null ? e : {
    attribution: t(e, "attribution") ? e.attribution : void 0,
    query: t(e, "query") ? e.query : void 0,
    warnings: t(e, "warnings") ? e.warnings : void 0,
    errors: t(e, "errors") ? e.errors : void 0
  };
}
function Rn(e) {
  if (e !== void 0) return e === null ? null : {
    attribution: e.attribution,
    query: e.query,
    warnings: e.warnings,
    errors: e.errors
  };
}
function Oa(e) {
  var i = !0;
  return i = i && "geocoding" in e, i = i && "features" in e, i;
}
function h(e) {
  return Jn(e);
}
function Jn(e, i) {
  return e == null ? e : {
    geocoding: wn(e.geocoding),
    bbox: t(e, "bbox") ? e.bbox : void 0,
    features: e.features.map(Sn)
  };
}
function va(e) {
  if (e !== void 0) return e === null ? null : {
    geocoding: Rn(e.geocoding),
    bbox: e.bbox,
    features: e.features.map(Tn)
  };
}
var Sa = {
  Openstreetmap: "openstreetmap",
  Openaddresses: "openaddresses",
  Whosonfirst: "whosonfirst",
  Geonames: "geonames"
};
function ba(e) {
  return Cn(e);
}
function Cn(e, i) {
  return e;
}
function Ta(e) {
  return e;
}
function wa(e) {
  return !0;
}
function ue(e) {
  return Fn(e);
}
function Fn(e, i) {
  return e == null ? e : {
    excludeTunnel: t(e, "exclude_tunnel") ? e.exclude_tunnel : void 0,
    excludeBridge: t(e, "exclude_bridge") ? e.exclude_bridge : void 0,
    excludeRamp: t(e, "exclude_ramp") ? e.exclude_ramp : void 0,
    excludeClosures: t(e, "exclude_closures") ? e.exclude_closures : void 0,
    minRoadClass: t(e, "min_road_class") ? S(e.min_road_class) : void 0,
    maxRoadClass: t(e, "max_road_class") ? S(e.max_road_class) : void 0
  };
}
function le(e) {
  if (e !== void 0) return e === null ? null : {
    exclude_tunnel: e.excludeTunnel,
    exclude_bridge: e.excludeBridge,
    exclude_ramp: e.excludeRamp,
    exclude_closures: e.excludeClosures,
    min_road_class: e.minRoadClass,
    max_road_class: e.maxRoadClass
  };
}
var Na = {
    Break: "break",
    Through: "through",
    Via: "via",
    BreakThrough: "break_through"
  },
  Ra = {
    Same: "same",
    Opposite: "opposite",
    Either: "either"
  };
function Ja(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function A(e) {
  return xn(e);
}
function xn(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    type: t(e, "type") ? e.type : void 0,
    heading: t(e, "heading") ? e.heading : void 0,
    headingTolerance: t(e, "heading_tolerance") ? e.heading_tolerance : void 0,
    minimumReachability: t(e, "minimum_reachability") ? e.minimum_reachability : void 0,
    radius: t(e, "radius") ? e.radius : void 0,
    rankCandidates: t(e, "rank_candidates") ? e.rank_candidates : void 0,
    preferredSide: t(e, "preferred_side") ? e.preferred_side : void 0,
    nodeSnapTolerance: t(e, "node_snap_tolerance") ? e.node_snap_tolerance : void 0,
    streetSideTolerance: t(e, "street_side_tolerance") ? e.street_side_tolerance : void 0,
    streetSideMaxDistance: t(e, "street_side_max_distance") ? e.street_side_max_distance : void 0,
    searchFilter: t(e, "search_filter") ? ue(e.search_filter) : void 0
  };
}
function L(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    type: e.type,
    heading: e.heading,
    heading_tolerance: e.headingTolerance,
    minimum_reachability: e.minimumReachability,
    radius: e.radius,
    rank_candidates: e.rankCandidates,
    preferred_side: e.preferredSide,
    node_snap_tolerance: e.nodeSnapTolerance,
    street_side_tolerance: e.streetSideTolerance,
    street_side_max_distance: e.streetSideMaxDistance,
    search_filter: le(e.searchFilter)
  };
}
function Ca(e) {
  var i = !0;
  return i = i && "locations" in e, i = i && "costing" in e, i;
}
function Fa(e) {
  return kn(e);
}
function kn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    locations: e.locations.map(A),
    costing: Z(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    avoidLocations: t(e, "avoid_locations") ? e.avoid_locations.map(A) : void 0,
    avoidPolygons: t(e, "avoid_polygons") ? e.avoid_polygons : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0
  };
}
function In(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    locations: e.locations.map(L),
    costing: e.costing,
    costing_options: l(e.costingOptions),
    avoid_locations: e.avoidLocations === void 0 ? void 0 : e.avoidLocations.map(L),
    avoid_polygons: e.avoidPolygons,
    directions_options: y(e.directionsOptions)
  };
}
function xa(e) {
  var i = !0;
  return i = i && "trip" in e, i;
}
function P(e) {
  return Mn(e);
}
function Mn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    trip: oe(e.trip)
  };
}
function ka(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    trip: ce(e.trip)
  };
}
function Ia(e) {
  return !0;
}
function Ma(e) {
  return En(e);
}
function En(e, i) {
  return e == null ? e : {
    originalIndex: t(e, "original_index") ? e.original_index : void 0
  };
}
function Ea(e) {
  if (e !== void 0) return e === null ? null : {
    original_index: e.originalIndex
  };
}
var Aa = {
  Same: "same",
  Opposite: "opposite",
  Either: "either"
};
function La(e) {
  return !0;
}
function Pa(e) {
  return An(e);
}
function An(e, i) {
  return e == null ? e : {
    heading: t(e, "heading") ? e.heading : void 0,
    headingTolerance: t(e, "heading_tolerance") ? e.heading_tolerance : void 0,
    minimumReachability: t(e, "minimum_reachability") ? e.minimum_reachability : void 0,
    radius: t(e, "radius") ? e.radius : void 0,
    rankCandidates: t(e, "rank_candidates") ? e.rank_candidates : void 0,
    preferredSide: t(e, "preferred_side") ? e.preferred_side : void 0,
    nodeSnapTolerance: t(e, "node_snap_tolerance") ? e.node_snap_tolerance : void 0,
    streetSideTolerance: t(e, "street_side_tolerance") ? e.street_side_tolerance : void 0,
    streetSideMaxDistance: t(e, "street_side_max_distance") ? e.street_side_max_distance : void 0,
    searchFilter: t(e, "search_filter") ? ue(e.search_filter) : void 0
  };
}
function Da(e) {
  if (e !== void 0) return e === null ? null : {
    heading: e.heading,
    heading_tolerance: e.headingTolerance,
    minimum_reachability: e.minimumReachability,
    radius: e.radius,
    rank_candidates: e.rankCandidates,
    preferred_side: e.preferredSide,
    node_snap_tolerance: e.nodeSnapTolerance,
    street_side_tolerance: e.streetSideTolerance,
    street_side_max_distance: e.streetSideMaxDistance,
    search_filter: le(e.searchFilter)
  };
}
var Ba = {
  Break: "break",
  Through: "through",
  Via: "via",
  BreakThrough: "break_through"
};
function Ga(e) {
  var i = !0;
  return i = i && "lat" in e, i = i && "lon" in e, i;
}
function Ha(e) {
  return Ln(e);
}
function Ln(e, i) {
  return e == null ? e : {
    lat: e.lat,
    lon: e.lon,
    type: t(e, "type") ? e.type : void 0
  };
}
function Wa(e) {
  if (e !== void 0) return e === null ? null : {
    lat: e.lat,
    lon: e.lon,
    type: e.type
  };
}
var za = {
  Break: "break",
  Through: "through",
  Via: "via",
  BreakThrough: "break_through"
};
function Ua(e) {
  return !0;
}
function Ka(e) {
  return Pn(e);
}
function Pn(e, i) {
  return e == null ? e : {
    type: t(e, "type") ? e.type : void 0
  };
}
function Va(e) {
  if (e !== void 0) return e === null ? null : {
    type: e.type
  };
}
var $a = {
  EdgeNames: "edge.names",
  EdgeLength: "edge.length",
  EdgeSpeed: "edge.speed",
  EdgeRoadClass: "edge.road_class",
  EdgeBeginHeading: "edge.begin_heading",
  EdgeEndHeading: "edge.end_heading",
  EdgeBeginShapeIndex: "edge.begin_shape_index",
  EdgeEndShapeIndex: "edge.end_shape_index",
  EdgeTraversability: "edge.traversability",
  EdgeUse: "edge.use",
  EdgeToll: "edge.toll",
  EdgeUnpaved: "edge.unpaved",
  EdgeTunnel: "edge.tunnel",
  EdgeBridge: "edge.bridge",
  EdgeRoundabout: "edge.roundabout",
  EdgeInternalIntersection: "edge.internal_intersection",
  EdgeDriveOnRight: "edge.drive_on_right",
  EdgeSurface: "edge.surface",
  EdgeSignExitNumber: "edge.sign.exit_number",
  EdgeSignExitBranch: "edge.sign.exit_branch",
  EdgeSignExitToward: "edge.sign.exit_toward",
  EdgeSignExitName: "edge.sign.exit_name",
  EdgeTravelMode: "edge.travel_mode",
  EdgeVehicleType: "edge.vehicle_type",
  EdgePedestrianType: "edge.pedestrian_type",
  EdgeBicycleType: "edge.bicycle_type",
  EdgeTransitType: "edge.transit_type",
  EdgeId: "edge.id",
  EdgeWayId: "edge.way_id",
  EdgeWeightedGrade: "edge.weighted_grade",
  EdgeMaxUpwardGrade: "edge.max_upward_grade",
  EdgeMaxDownwardGrade: "edge.max_downward_grade",
  EdgeMeanElevation: "edge.mean_elevation",
  EdgeLaneCount: "edge.lane_count",
  EdgeCycleLane: "edge.cycle_lane",
  EdgeBicycleNetwork: "edge.bicycle_network",
  EdgeSacScale: "edge.sac_scale",
  EdgeSidewalk: "edge.sidewalk",
  EdgeDensity: "edge.density",
  EdgeSpeedLimit: "edge.speed_limit",
  EdgeTruckSpeed: "edge.truck_speed",
  EdgeTruckRoute: "edge.truck_route",
  NodeIntersectingEdgeBeginHeading: "node.intersecting_edge.begin_heading",
  NodeIntersectingEdgeFromEdgeNameConsistency: "node.intersecting_edge.from_edge_name_consistency",
  NodeIntersectingEdgeToEdgeNameConsistency: "node.intersecting_edge.to_edge_name_consistency",
  NodeIntersectingEdgeDriveability: "node.intersecting_edge.driveability",
  NodeIntersectingEdgeCyclability: "node.intersecting_edge.cyclability",
  NodeIntersectingEdgeWalkability: "node.intersecting_edge.walkability",
  NodeIntersectingEdgeUse: "node.intersecting_edge.use",
  NodeIntersectingEdgeRoadClass: "node.intersecting_edge.road_class",
  NodeElapsedTime: "node.elapsed_time",
  NodeAdminIndex: "node.admin_index",
  NodeType: "node.type",
  NodeFork: "node.fork",
  NodeTimeZone: "node.time_zone",
  OsmChangeset: "osm_changeset",
  Shape: "shape",
  AdminCountryCode: "admin.country_code",
  AdminCountryText: "admin.country_text",
  AdminStateCode: "admin.state_code",
  AdminStateText: "admin.state_text",
  MatchedPoint: "matched.point",
  MatchedType: "matched.type",
  MatchedEdgeIndex: "matched.edge_index",
  MatchedBeginRouteDiscontinuity: "matched.begin_route_discontinuity",
  MatchedEndRouteDiscontinuity: "matched.end_route_discontinuity",
  MatchedDistanceAlongEdge: "matched.distance_along_edge",
  MatchedDistanceFromTracePoint: "matched.distance_from_trace_point"
};
function ge(e) {
  return Dn(e);
}
function Dn(e, i) {
  return e;
}
function pe(e) {
  return e;
}
var Za = {
  Include: "include",
  Exclude: "exclude"
};
function Xa(e) {
  var i = !0;
  return i = i && "attributes" in e, i = i && "action" in e, i;
}
function Qa(e) {
  return Bn(e);
}
function Bn(e, i) {
  return e == null ? e : {
    attributes: e.attributes.map(ge),
    action: e.action
  };
}
function Ya(e) {
  if (e !== void 0) return e === null ? null : {
    attributes: e.attributes.map(pe),
    action: e.action
  };
}
var qa = {
    PavedSmooth: "paved_smooth",
    Paved: "paved",
    PavedRough: "paved_rough",
    Compacted: "compacted",
    Dirt: "dirt",
    Gravel: "gravel",
    Path: "path",
    Impassable: "impassable"
  },
  ja = {
    Car: "car",
    Motorcycle: "motorcycle",
    Bus: "bus",
    TractorTrailer: "tractor_trailer"
  },
  ed = {
    Foot: "foot",
    Wheelchair: "wheelchair",
    Segway: "segway"
  },
  id = {
    Road: "road",
    Cross: "cross",
    Hybrid: "hybrid",
    Mountain: "mountain"
  },
  td = {
    Tram: "tram",
    Metro: "metro",
    Rail: "rail",
    Bus: "bus",
    Ferry: "ferry",
    CableCar: "cable_car",
    Gondola: "gondola",
    Funicular: "funicular"
  },
  nd = {
    None: "none",
    Shared: "shared",
    Dedicated: "dedicated",
    Separated: "separated"
  },
  rd = {
    Left: "left",
    Right: "right",
    Both: "both",
    None: "none"
  };
function od(e) {
  return !0;
}
function _e(e) {
  return Gn(e);
}
function Gn(e, i) {
  return e == null ? e : {
    names: t(e, "names") ? e.names : void 0,
    length: t(e, "length") ? e.length : void 0,
    speed: t(e, "speed") ? e.speed : void 0,
    roadClass: t(e, "road_class") ? S(e.road_class) : void 0,
    beginHeading: t(e, "begin_heading") ? e.begin_heading : void 0,
    endHeading: t(e, "end_heading") ? e.end_heading : void 0,
    beginShapeIndex: t(e, "begin_shape_index") ? e.begin_shape_index : void 0,
    endShapeIndex: t(e, "end_shape_index") ? e.end_shape_index : void 0,
    traversability: t(e, "traversability") ? v(e.traversability) : void 0,
    use: t(e, "use") ? X(e.use) : void 0,
    toll: t(e, "toll") ? e.toll : void 0,
    unpaved: t(e, "unpaved") ? e.unpaved : void 0,
    tunnel: t(e, "tunnel") ? e.tunnel : void 0,
    bridge: t(e, "bridge") ? e.bridge : void 0,
    roundabout: t(e, "roundabout") ? e.roundabout : void 0,
    internalIntersection: t(e, "internal_intersection") ? e.internal_intersection : void 0,
    driveOnRight: t(e, "drive_on_right") ? e.drive_on_right : void 0,
    surface: t(e, "surface") ? e.surface : void 0,
    sign: t(e, "sign") ? gi(e.sign) : void 0,
    travelMode: t(e, "travel_mode") ? te(e.travel_mode) : void 0,
    vehicleType: t(e, "vehicle_type") ? e.vehicle_type : void 0,
    pedestrianType: t(e, "pedestrian_type") ? e.pedestrian_type : void 0,
    bicycleType: t(e, "bicycle_type") ? e.bicycle_type : void 0,
    transitType: t(e, "transit_type") ? e.transit_type : void 0,
    id: t(e, "id") ? e.id : void 0,
    wayId: t(e, "way_id") ? e.way_id : void 0,
    weightedGrade: t(e, "weighted_grade") ? e.weighted_grade : void 0,
    maxUpwardGrade: t(e, "max_upward_grade") ? e.max_upward_grade : void 0,
    maxDownwardGrade: t(e, "max_downward_grade") ? e.max_downward_grade : void 0,
    meanElevation: t(e, "mean_elevation") ? e.mean_elevation : void 0,
    laneCount: t(e, "lane_count") ? e.lane_count : void 0,
    cycleLane: t(e, "cycle_lane") ? e.cycle_lane : void 0,
    bicycleNetwork: t(e, "bicycle_network") ? e.bicycle_network : void 0,
    sacScale: t(e, "sac_scale") ? e.sac_scale : void 0,
    sidewalk: t(e, "sidewalk") ? e.sidewalk : void 0,
    density: t(e, "density") ? e.density : void 0,
    speedLimit: t(e, "speed_limit") ? e.speed_limit : void 0,
    truckSpeed: t(e, "truck_speed") ? e.truck_speed : void 0,
    truckRoute: t(e, "truck_route") ? e.truck_route : void 0,
    endNode: t(e, "end_node") ? bi(e.end_node) : void 0
  };
}
function fe(e) {
  if (e !== void 0) return e === null ? null : {
    names: e.names,
    length: e.length,
    speed: e.speed,
    road_class: e.roadClass,
    begin_heading: e.beginHeading,
    end_heading: e.endHeading,
    begin_shape_index: e.beginShapeIndex,
    end_shape_index: e.endShapeIndex,
    traversability: e.traversability,
    use: e.use,
    toll: e.toll,
    unpaved: e.unpaved,
    tunnel: e.tunnel,
    bridge: e.bridge,
    roundabout: e.roundabout,
    internal_intersection: e.internalIntersection,
    drive_on_right: e.driveOnRight,
    surface: e.surface,
    sign: _i(e.sign),
    travel_mode: e.travelMode,
    vehicle_type: e.vehicleType,
    pedestrian_type: e.pedestrianType,
    bicycle_type: e.bicycleType,
    transit_type: e.transitType,
    id: e.id,
    way_id: e.wayId,
    weighted_grade: e.weightedGrade,
    max_upward_grade: e.maxUpwardGrade,
    max_downward_grade: e.maxDownwardGrade,
    mean_elevation: e.meanElevation,
    lane_count: e.laneCount,
    cycle_lane: e.cycleLane,
    bicycle_network: e.bicycleNetwork,
    sac_scale: e.sacScale,
    sidewalk: e.sidewalk,
    density: e.density,
    speed_limit: e.speedLimit,
    truck_speed: e.truckSpeed,
    truck_route: e.truckRoute,
    end_node: wi(e.endNode)
  };
}
function cd(e) {
  return !0;
}
function ye(e) {
  return Hn(e);
}
function Hn(e, i) {
  return e == null ? e : {
    edges: t(e, "edges") ? e.edges.map(_e) : void 0,
    admins: t(e, "admins") ? e.admins.map(z) : void 0,
    matchedPoints: t(e, "matched_points") ? e.matched_points.map(ae) : void 0,
    osmChangeset: t(e, "osm_changeset") ? e.osm_changeset : void 0,
    shape: t(e, "shape") ? e.shape : void 0,
    confidenceScore: t(e, "confidence_score") ? e.confidence_score : void 0
  };
}
function he(e) {
  if (e !== void 0) return e === null ? null : {
    edges: e.edges === void 0 ? void 0 : e.edges.map(fe),
    admins: e.admins === void 0 ? void 0 : e.admins.map(U),
    matched_points: e.matchedPoints === void 0 ? void 0 : e.matchedPoints.map(de),
    osm_changeset: e.osmChangeset,
    shape: e.shape,
    confidence_score: e.confidenceScore
  };
}
var ad = {
  Include: "include",
  Exclude: "exclude"
};
function dd(e) {
  var i = !0;
  return i = i && "attributes" in e, i = i && "action" in e, i;
}
function me(e) {
  return Wn(e);
}
function Wn(e, i) {
  return e == null ? e : {
    attributes: e.attributes.map(ge),
    action: e.action
  };
}
function Oe(e) {
  if (e !== void 0) return e === null ? null : {
    attributes: e.attributes.map(pe),
    action: e.action
  };
}
var sd = {
  EdgeWalk: "edge_walk",
  MapSnap: "map_snap",
  WalkOrSnap: "walk_or_snap"
};
function ud(e) {
  var i = !0;
  return i = i && "costing" in e, i;
}
function ld(e) {
  return zn(e);
}
function zn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    shape: t(e, "shape") ? e.shape.map(k) : void 0,
    encodedPolyline: t(e, "encoded_polyline") ? e.encoded_polyline : void 0,
    costing: x(e.costing),
    costingOptions: t(e, "costing_options") ? u(e.costing_options) : void 0,
    shapeMatch: t(e, "shape_match") ? e.shape_match : void 0,
    directionsOptions: t(e, "directions_options") ? f(e.directions_options) : void 0,
    filters: t(e, "filters") ? me(e.filters) : void 0
  };
}
function Un(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    shape: e.shape === void 0 ? void 0 : e.shape.map(I),
    encoded_polyline: e.encodedPolyline,
    costing: e.costing,
    costing_options: l(e.costingOptions),
    shape_match: e.shapeMatch,
    directions_options: y(e.directionsOptions),
    filters: Oe(e.filters)
  };
}
function gd(e) {
  return !0;
}
function pd(e) {
  return Kn(e);
}
function Kn(e, i) {
  return e == null ? e : {
    filters: t(e, "filters") ? me(e.filters) : void 0
  };
}
function _d(e) {
  if (e !== void 0) return e === null ? null : {
    filters: Oe(e.filters)
  };
}
function fd(e) {
  return !0;
}
function Vn(e) {
  return $n(e);
}
function $n(e, i) {
  return e == null ? e : {
    edges: t(e, "edges") ? e.edges.map(_e) : void 0,
    admins: t(e, "admins") ? e.admins.map(z) : void 0,
    matchedPoints: t(e, "matched_points") ? e.matched_points.map(ae) : void 0,
    osmChangeset: t(e, "osm_changeset") ? e.osm_changeset : void 0,
    shape: t(e, "shape") ? e.shape : void 0,
    confidenceScore: t(e, "confidence_score") ? e.confidence_score : void 0,
    id: t(e, "id") ? e.id : void 0,
    units: t(e, "units") ? N(e.units) : void 0,
    alternatePaths: t(e, "alternate_paths") ? e.alternate_paths.map(ye) : void 0
  };
}
function yd(e) {
  if (e !== void 0) return e === null ? null : {
    edges: e.edges === void 0 ? void 0 : e.edges.map(fe),
    admins: e.admins === void 0 ? void 0 : e.admins.map(U),
    matched_points: e.matchedPoints === void 0 ? void 0 : e.matchedPoints.map(de),
    osm_changeset: e.osmChangeset,
    shape: e.shape,
    confidence_score: e.confidenceScore,
    id: e.id,
    units: e.units,
    alternate_paths: e.alternatePaths === void 0 ? void 0 : e.alternatePaths.map(he)
  };
}
function hd(e) {
  return !0;
}
function md(e) {
  return Zn(e);
}
function Zn(e, i) {
  return e == null ? e : {
    id: t(e, "id") ? e.id : void 0,
    units: t(e, "units") ? N(e.units) : void 0,
    alternatePaths: t(e, "alternate_paths") ? e.alternate_paths.map(ye) : void 0
  };
}
function Od(e) {
  if (e !== void 0) return e === null ? null : {
    id: e.id,
    units: e.units,
    alternate_paths: e.alternatePaths === void 0 ? void 0 : e.alternatePaths.map(he)
  };
}
function vd(e) {
  return !0;
}
function Sd(e) {
  return Xn(e);
}
function Xn(e, i) {
  return e == null ? e : {
    height: t(e, "height") ? e.height : void 0,
    width: t(e, "width") ? e.width : void 0,
    length: t(e, "length") ? e.length : void 0,
    weight: t(e, "weight") ? e.weight : void 0,
    axleLoad: t(e, "axle_load") ? e.axle_load : void 0,
    hazmat: t(e, "hazmat") ? e.hazmat : void 0
  };
}
function bd(e) {
  if (e !== void 0) return e === null ? null : {
    height: e.height,
    width: e.width,
    length: e.length,
    weight: e.weight,
    axle_load: e.axleLoad,
    hazmat: e.hazmat
  };
}
function Td(e) {
  var i = !0;
  return i = i && "tzId" in e, i = i && "baseUtcOffset" in e, i = i && "dstOffset" in e, i;
}
function Qn(e) {
  return Yn(e);
}
function Yn(e, i) {
  return e == null ? e : {
    tzId: e.tz_id,
    baseUtcOffset: e.base_utc_offset,
    dstOffset: e.dst_offset
  };
}
function wd(e) {
  if (e !== void 0) return e === null ? null : {
    tz_id: e.tzId,
    base_utc_offset: e.baseUtcOffset,
    dst_offset: e.dstOffset
  };
}
var Nd = /*#__PURE__*/function (_b) {
  _inherits(Nd, _b);
  function Nd() {
    _classCallCheck(this, Nd);
    return _possibleConstructorReturn(this, _getPrototypeOf(Nd).apply(this, arguments));
  }
  _createClass(Nd, [{
    key: "elevationRaw",
    /**
     * The Stadia elevation API allows you to get the elevation of any point on earth. You can pass either a simple set of points or a Google encoded polyline string. This pairs well with our routing APIs, so you can generate an elevation profile for your next bike or run.
     * Get the elevation profile along a polyline or at a point.
     */
    value: function () {
      var _elevationRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context10.next = 4;
              return this.request({
                path: "/elevation/v1",
                method: "POST",
                headers: o,
                query: n,
                body: Di(i.heightRequest)
              }, r);
            case 4:
              c = _context10.sent;
              return _context10.abrupt("return", new d(c, function (a) {
                return Bi(a);
              }));
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function elevationRaw(_x7, _x8) {
        return _elevationRaw.apply(this, arguments);
      }
      return elevationRaw;
    }()
    /**
     * The Stadia elevation API allows you to get the elevation of any point on earth. You can pass either a simple set of points or a Google encoded polyline string. This pairs well with our routing APIs, so you can generate an elevation profile for your next bike or run.
     * Get the elevation profile along a polyline or at a point.
     */
  }, {
    key: "elevation",
    value: function () {
      var _elevation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var i,
          r,
          _args11 = arguments;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              i = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
              r = _args11.length > 1 ? _args11[1] : undefined;
              _context11.next = 4;
              return this.elevationRaw(i, r);
            case 4:
              _context11.next = 6;
              return _context11.sent.value();
            case 6:
              return _context11.abrupt("return", _context11.sent);
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function elevation() {
        return _elevation.apply(this, arguments);
      }
      return elevation;
    }()
    /**
     * The Stadia TZ API provides time zone information, as well as information about any special offset (such as DST) in effect based on the latest IANA TZDB. Note that this API may not be accurate for timestamps in the past and does not claim to report precise nautical times in the open ocean beyond territorial waters.
     * Get the current time zone information for any point on earth.
     */
  }, {
    key: "tzLookupRaw",
    value: function () {
      var _tzLookupRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!(i.lat === null || i.lat === void 0)) {
                _context12.next = 2;
                break;
              }
              throw new g("lat", "Required parameter requestParameters.lat was null or undefined when calling tzLookup.");
            case 2:
              if (!(i.lng === null || i.lng === void 0)) {
                _context12.next = 4;
                break;
              }
              throw new g("lng", "Required parameter requestParameters.lng was null or undefined when calling tzLookup.");
            case 4:
              n = {};
              i.lat !== void 0 && (n.lat = i.lat), i.lng !== void 0 && (n.lng = i.lng), i.timestamp !== void 0 && (n.timestamp = i.timestamp);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context12.next = 10;
              return this.request({
                path: "/tz/lookup/v1",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 10:
              c = _context12.sent;
              return _context12.abrupt("return", new d(c, function (a) {
                return Qn(a);
              }));
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function tzLookupRaw(_x9, _x10) {
        return _tzLookupRaw.apply(this, arguments);
      }
      return tzLookupRaw;
    }()
    /**
     * The Stadia TZ API provides time zone information, as well as information about any special offset (such as DST) in effect based on the latest IANA TZDB. Note that this API may not be accurate for timestamps in the past and does not claim to report precise nautical times in the open ocean beyond territorial waters.
     * Get the current time zone information for any point on earth.
     */
  }, {
    key: "tzLookup",
    value: function () {
      var _tzLookup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(i, r) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.tzLookupRaw(i, r);
            case 2:
              _context13.next = 4;
              return _context13.sent.value();
            case 4:
              return _context13.abrupt("return", _context13.sent);
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function tzLookup(_x11, _x12) {
        return _tzLookup.apply(this, arguments);
      }
      return tzLookup;
    }()
  }]);
  return Nd;
}(b);
var Rd = /*#__PURE__*/function (_b2) {
  _inherits(Rd, _b2);
  function Rd() {
    _classCallCheck(this, Rd);
    return _possibleConstructorReturn(this, _getPrototypeOf(Rd).apply(this, arguments));
  }
  _createClass(Rd, [{
    key: "isochroneRaw",
    /**
     * The isochrone API lets you compute or visualize areas of roughly equal travel time based on the routing graph. The resulting polygon can be rendered on a map and shaded much like elevation contours and used for exploring urban mobility.
     * Calculate areas of equal travel time from a location.
     */
    value: function () {
      var _isochroneRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context14.next = 4;
              return this.request({
                path: "/isochrone/v1",
                method: "POST",
                headers: o,
                query: n,
                body: ji(i.isochroneRequest)
              }, r);
            case 4:
              c = _context14.sent;
              return _context14.abrupt("return", new d(c, function (a) {
                return et(a);
              }));
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function isochroneRaw(_x13, _x14) {
        return _isochroneRaw.apply(this, arguments);
      }
      return isochroneRaw;
    }()
    /**
     * The isochrone API lets you compute or visualize areas of roughly equal travel time based on the routing graph. The resulting polygon can be rendered on a map and shaded much like elevation contours and used for exploring urban mobility.
     * Calculate areas of equal travel time from a location.
     */
  }, {
    key: "isochrone",
    value: function () {
      var _isochrone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var i,
          r,
          _args15 = arguments;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              i = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
              r = _args15.length > 1 ? _args15[1] : undefined;
              _context15.next = 4;
              return this.isochroneRaw(i, r);
            case 4:
              _context15.next = 6;
              return _context15.sent.value();
            case 6:
              return _context15.abrupt("return", _context15.sent);
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function isochrone() {
        return _isochrone.apply(this, arguments);
      }
      return isochrone;
    }()
    /**
     * The map matching API transforms a recorded route into navigation instructions like you would get from the `route` endpoint. The input can be in the form of either an encoded polyline, or (optionally) timestamped coordinates.
     * Match a recorded route to the road network.
     */
  }, {
    key: "mapMatchRaw",
    value: function () {
      var _mapMatchRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context16.next = 4;
              return this.request({
                path: "/map_match/v1",
                method: "POST",
                headers: o,
                query: n,
                body: Ct(i.mapMatchRequest)
              }, r);
            case 4:
              c = _context16.sent;
              return _context16.abrupt("return", new d(c, function (a) {
                return zt(a);
              }));
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function mapMatchRaw(_x15, _x16) {
        return _mapMatchRaw.apply(this, arguments);
      }
      return mapMatchRaw;
    }()
    /**
     * The map matching API transforms a recorded route into navigation instructions like you would get from the `route` endpoint. The input can be in the form of either an encoded polyline, or (optionally) timestamped coordinates.
     * Match a recorded route to the road network.
     */
  }, {
    key: "mapMatch",
    value: function () {
      var _mapMatch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var i,
          r,
          _args17 = arguments;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              i = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
              r = _args17.length > 1 ? _args17[1] : undefined;
              _context17.next = 4;
              return this.mapMatchRaw(i, r);
            case 4:
              _context17.next = 6;
              return _context17.sent.value();
            case 6:
              return _context17.abrupt("return", _context17.sent);
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function mapMatch() {
        return _mapMatch.apply(this, arguments);
      }
      return mapMatch;
    }()
    /**
     * The nearest roads API allows you query for detailed information about streets and intersections near the input locations.
     * Find the nearest roads to the set of input locations.
     */
  }, {
    key: "nearestRoadsRaw",
    value: function () {
      var _nearestRoadsRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context18.next = 4;
              return this.request({
                path: "/nearest_roads/v1",
                method: "POST",
                headers: o,
                query: n,
                body: an(i.nearestRoadsRequest)
              }, r);
            case 4:
              c = _context18.sent;
              return _context18.abrupt("return", new d(c, function (a) {
                return a.map(vt);
              }));
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function nearestRoadsRaw(_x17, _x18) {
        return _nearestRoadsRaw.apply(this, arguments);
      }
      return nearestRoadsRaw;
    }()
    /**
     * The nearest roads API allows you query for detailed information about streets and intersections near the input locations.
     * Find the nearest roads to the set of input locations.
     */
  }, {
    key: "nearestRoads",
    value: function () {
      var _nearestRoads = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var i,
          r,
          _args19 = arguments;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              i = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
              r = _args19.length > 1 ? _args19[1] : undefined;
              _context19.next = 4;
              return this.nearestRoadsRaw(i, r);
            case 4:
              _context19.next = 6;
              return _context19.sent.value();
            case 6:
              return _context19.abrupt("return", _context19.sent);
            case 7:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function nearestRoads() {
        return _nearestRoads.apply(this, arguments);
      }
      return nearestRoads;
    }()
    /**
     * The optimized route API is a mix of the matrix and normal route API. For an optimized route, the start and end point are fixed, but the intermediate points will be re-ordered to form an optimal route visiting all nodes once. Note that all matrix endpoints have a limit of 1000 elements, regardless of the costing/mode of travel. A matrix request with 3 inputs and 5 outputs has 3 x 5 = 15 elements. This means you could send a 100 x 10 or 20 x 50 matrix request (each having 1000 elements), but not 40 x 30 as it has 1200 elements.
     * Calculate an optimized route between a known start and end point.
     */
  }, {
    key: "optimizedRouteRaw",
    value: function () {
      var _optimizedRouteRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context20.next = 4;
              return this.request({
                path: "/optimized_route/v1",
                method: "POST",
                headers: o,
                query: n,
                body: sn(i.optimizedRouteRequest)
              }, r);
            case 4:
              c = _context20.sent;
              return _context20.abrupt("return", new d(c, function (a) {
                return P(a);
              }));
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function optimizedRouteRaw(_x19, _x20) {
        return _optimizedRouteRaw.apply(this, arguments);
      }
      return optimizedRouteRaw;
    }()
    /**
     * The optimized route API is a mix of the matrix and normal route API. For an optimized route, the start and end point are fixed, but the intermediate points will be re-ordered to form an optimal route visiting all nodes once. Note that all matrix endpoints have a limit of 1000 elements, regardless of the costing/mode of travel. A matrix request with 3 inputs and 5 outputs has 3 x 5 = 15 elements. This means you could send a 100 x 10 or 20 x 50 matrix request (each having 1000 elements), but not 40 x 30 as it has 1200 elements.
     * Calculate an optimized route between a known start and end point.
     */
  }, {
    key: "optimizedRoute",
    value: function () {
      var _optimizedRoute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var i,
          r,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              i = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
              r = _args21.length > 1 ? _args21[1] : undefined;
              _context21.next = 4;
              return this.optimizedRouteRaw(i, r);
            case 4:
              _context21.next = 6;
              return _context21.sent.value();
            case 6:
              return _context21.abrupt("return", _context21.sent);
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function optimizedRoute() {
        return _optimizedRoute.apply(this, arguments);
      }
      return optimizedRoute;
    }()
    /**
     * The route (turn-by-turn) API computes routes between two or more locations. It supports a variety of tunable costing methods, and supports routing through intermediate waypoints and discontinuous multi-leg routes.
     * Get turn by turn routing instructions between two or more locations.
     */
  }, {
    key: "routeRaw",
    value: function () {
      var _routeRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context22.next = 4;
              return this.request({
                path: "/route/v1",
                method: "POST",
                headers: o,
                query: n,
                body: In(i.routeRequest)
              }, r);
            case 4:
              c = _context22.sent;
              return _context22.abrupt("return", new d(c, function (a) {
                return P(a);
              }));
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function routeRaw(_x21, _x22) {
        return _routeRaw.apply(this, arguments);
      }
      return routeRaw;
    }()
    /**
     * The route (turn-by-turn) API computes routes between two or more locations. It supports a variety of tunable costing methods, and supports routing through intermediate waypoints and discontinuous multi-leg routes.
     * Get turn by turn routing instructions between two or more locations.
     */
  }, {
    key: "route",
    value: function () {
      var _route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var i,
          r,
          _args23 = arguments;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              i = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
              r = _args23.length > 1 ? _args23[1] : undefined;
              _context23.next = 4;
              return this.routeRaw(i, r);
            case 4:
              _context23.next = 6;
              return _context23.sent.value();
            case 6:
              return _context23.abrupt("return", _context23.sent);
            case 7:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function route() {
        return _route.apply(this, arguments);
      }
      return route;
    }()
    /**
     * The time distance matrix API lets you compare travel times between a set of possible start and end points. Note that all matrix endpoints have a limit of 1000 elements, regardless of the costing/mode of travel. A matrix request with 3 inputs and 5 outputs has 3 x 5 = 15 elements. This means you could send a 100 x 10 or 20 x 50 matrix request (each having 1000 elements), but not 40 x 30 as it has 1200 elements.
     * Calculate a time distance matrix for a grid of start and end points.
     */
  }, {
    key: "timeDistanceMatrixRaw",
    value: function () {
      var _timeDistanceMatrixRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context24.next = 4;
              return this.request({
                path: "/matrix/v1",
                method: "POST",
                headers: o,
                query: n,
                body: Yt(i.matrixRequest)
              }, r);
            case 4:
              c = _context24.sent;
              return _context24.abrupt("return", new d(c, function (a) {
                return tn(a);
              }));
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function timeDistanceMatrixRaw(_x23, _x24) {
        return _timeDistanceMatrixRaw.apply(this, arguments);
      }
      return timeDistanceMatrixRaw;
    }()
    /**
     * The time distance matrix API lets you compare travel times between a set of possible start and end points. Note that all matrix endpoints have a limit of 1000 elements, regardless of the costing/mode of travel. A matrix request with 3 inputs and 5 outputs has 3 x 5 = 15 elements. This means you could send a 100 x 10 or 20 x 50 matrix request (each having 1000 elements), but not 40 x 30 as it has 1200 elements.
     * Calculate a time distance matrix for a grid of start and end points.
     */
  }, {
    key: "timeDistanceMatrix",
    value: function () {
      var _timeDistanceMatrix = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var i,
          r,
          _args25 = arguments;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              i = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
              r = _args25.length > 1 ? _args25[1] : undefined;
              _context25.next = 4;
              return this.timeDistanceMatrixRaw(i, r);
            case 4:
              _context25.next = 6;
              return _context25.sent.value();
            case 6:
              return _context25.abrupt("return", _context25.sent);
            case 7:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function timeDistanceMatrix() {
        return _timeDistanceMatrix.apply(this, arguments);
      }
      return timeDistanceMatrix;
    }()
    /**
     * The trace attributes endpoint retrieves detailed information along a route, returning details for each section along the path, as well as any intersections encountered. In addition to tracing a recording route, this is great for providing just-in-time info to navigation applications, enabling them to conserve resources by omitting info like speed limits upfront that may be irrelevant if the user goes off-route.
     * Trace the attributes of roads visited on a route.
     */
  }, {
    key: "traceAttributesRaw",
    value: function () {
      var _traceAttributesRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              n = {}, o = {};
              o["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context26.next = 4;
              return this.request({
                path: "/trace_attributes/v1",
                method: "POST",
                headers: o,
                query: n,
                body: Un(i.traceAttributesRequest)
              }, r);
            case 4:
              c = _context26.sent;
              return _context26.abrupt("return", new d(c, function (a) {
                return Vn(a);
              }));
            case 6:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function traceAttributesRaw(_x25, _x26) {
        return _traceAttributesRaw.apply(this, arguments);
      }
      return traceAttributesRaw;
    }()
    /**
     * The trace attributes endpoint retrieves detailed information along a route, returning details for each section along the path, as well as any intersections encountered. In addition to tracing a recording route, this is great for providing just-in-time info to navigation applications, enabling them to conserve resources by omitting info like speed limits upfront that may be irrelevant if the user goes off-route.
     * Trace the attributes of roads visited on a route.
     */
  }, {
    key: "traceAttributes",
    value: function () {
      var _traceAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var i,
          r,
          _args27 = arguments;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              i = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
              r = _args27.length > 1 ? _args27[1] : undefined;
              _context27.next = 4;
              return this.traceAttributesRaw(i, r);
            case 4:
              _context27.next = 6;
              return _context27.sent.value();
            case 6:
              return _context27.abrupt("return", _context27.sent);
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function traceAttributes() {
        return _traceAttributes.apply(this, arguments);
      }
      return traceAttributes;
    }()
  }]);
  return Rd;
}(b);
var qn = /*#__PURE__*/function (_b3) {
  _inherits(qn, _b3);
  function qn() {
    _classCallCheck(this, qn);
    return _possibleConstructorReturn(this, _getPrototypeOf(qn).apply(this, arguments));
  }
  _createClass(qn, [{
    key: "autocompleteRaw",
    /**
     * Autocomplete enables interactive search-as-you-type user experiences, suggesting places as you type, along with information that will help your users find the correct place quickly.
     * Search and geocode quickly based on partial input.
     */
    value: function () {
      var _autocompleteRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!(i.text === null || i.text === void 0)) {
                _context28.next = 2;
                break;
              }
              throw new g("text", "Required parameter requestParameters.text was null or undefined when calling autocomplete.");
            case 2:
              n = {};
              i.text !== void 0 && (n.text = i.text), i.focusPointLat !== void 0 && (n["focus.point.lat"] = i.focusPointLat), i.focusPointLon !== void 0 && (n["focus.point.lon"] = i.focusPointLon), i.boundaryRectMinLat !== void 0 && (n["boundary.rect.min_lat"] = i.boundaryRectMinLat), i.boundaryRectMaxLat !== void 0 && (n["boundary.rect.max_lat"] = i.boundaryRectMaxLat), i.boundaryRectMinLon !== void 0 && (n["boundary.rect.min_lon"] = i.boundaryRectMinLon), i.boundaryRectMaxLon !== void 0 && (n["boundary.rect.max_lon"] = i.boundaryRectMaxLon), i.boundaryCircleLat !== void 0 && (n["boundary.circle.lat"] = i.boundaryCircleLat), i.boundaryCircleLon !== void 0 && (n["boundary.circle.lon"] = i.boundaryCircleLon), i.boundaryCircleRadius !== void 0 && (n["boundary.circle.radius"] = i.boundaryCircleRadius), i.boundaryCountry && (n["boundary.country"] = i.boundaryCountry.join(s.csv)), i.boundaryGid !== void 0 && (n["boundary.gid"] = i.boundaryGid), i.layers && (n.layers = i.layers.join(s.csv)), i.sources && (n.sources = i.sources.join(s.csv)), i.size !== void 0 && (n.size = i.size), i.lang !== void 0 && (n.lang = i.lang);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context28.next = 8;
              return this.request({
                path: "/geocoding/v1/autocomplete",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 8:
              c = _context28.sent;
              return _context28.abrupt("return", new d(c, function (a) {
                return h(a);
              }));
            case 10:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function autocompleteRaw(_x27, _x28) {
        return _autocompleteRaw.apply(this, arguments);
      }
      return autocompleteRaw;
    }()
    /**
     * Autocomplete enables interactive search-as-you-type user experiences, suggesting places as you type, along with information that will help your users find the correct place quickly.
     * Search and geocode quickly based on partial input.
     */
  }, {
    key: "autocomplete",
    value: function () {
      var _autocomplete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(i, r) {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return this.autocompleteRaw(i, r);
            case 2:
              _context29.next = 4;
              return _context29.sent.value();
            case 4:
              return _context29.abrupt("return", _context29.sent);
            case 5:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function autocomplete(_x29, _x30) {
        return _autocomplete.apply(this, arguments);
      }
      return autocomplete;
    }()
    /**
     * Many search result components include an associated GID field (for example, an address may have a `localadmin_gid`). The place endpoint lets you look up these places directly by ID. Note that these IDs are not stable for all sources. See the [online documentation](https://docs.stadiamaps.com/geocoding-search-autocomplete/place-lookup/) for details.
     * Retrieve details of a place using its GID.
     */
  }, {
    key: "placeRaw",
    value: function () {
      var _placeRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!(i.ids === null || i.ids === void 0)) {
                _context30.next = 2;
                break;
              }
              throw new g("ids", "Required parameter requestParameters.ids was null or undefined when calling place.");
            case 2:
              n = {};
              i.ids && (n.ids = i.ids.join(s.csv)), i.lang !== void 0 && (n.lang = i.lang);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context30.next = 8;
              return this.request({
                path: "/geocoding/v1/place",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 8:
              c = _context30.sent;
              return _context30.abrupt("return", new d(c, function (a) {
                return h(a);
              }));
            case 10:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function placeRaw(_x31, _x32) {
        return _placeRaw.apply(this, arguments);
      }
      return placeRaw;
    }()
    /**
     * Many search result components include an associated GID field (for example, an address may have a `localadmin_gid`). The place endpoint lets you look up these places directly by ID. Note that these IDs are not stable for all sources. See the [online documentation](https://docs.stadiamaps.com/geocoding-search-autocomplete/place-lookup/) for details.
     * Retrieve details of a place using its GID.
     */
  }, {
    key: "place",
    value: function () {
      var _place = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(i, r) {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this.placeRaw(i, r);
            case 2:
              _context31.next = 4;
              return _context31.sent.value();
            case 4:
              return _context31.abrupt("return", _context31.sent);
            case 5:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function place(_x33, _x34) {
        return _place.apply(this, arguments);
      }
      return place;
    }()
    /**
     * Reverse geocoding and search finds places and addresses near any geographic coordinates.
     * Find places and addresses near geographic coordinates (reverse geocoding).
     */
  }, {
    key: "reverseRaw",
    value: function () {
      var _reverseRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!(i.pointLat === null || i.pointLat === void 0)) {
                _context32.next = 2;
                break;
              }
              throw new g("pointLat", "Required parameter requestParameters.pointLat was null or undefined when calling reverse.");
            case 2:
              if (!(i.pointLon === null || i.pointLon === void 0)) {
                _context32.next = 4;
                break;
              }
              throw new g("pointLon", "Required parameter requestParameters.pointLon was null or undefined when calling reverse.");
            case 4:
              n = {};
              i.pointLat !== void 0 && (n["point.lat"] = i.pointLat), i.pointLon !== void 0 && (n["point.lon"] = i.pointLon), i.boundaryCircleRadius !== void 0 && (n["boundary.circle.radius"] = i.boundaryCircleRadius), i.layers && (n.layers = i.layers.join(s.csv)), i.sources && (n.sources = i.sources.join(s.csv)), i.boundaryCountry && (n["boundary.country"] = i.boundaryCountry.join(s.csv)), i.boundaryGid !== void 0 && (n["boundary.gid"] = i.boundaryGid), i.size !== void 0 && (n.size = i.size), i.lang !== void 0 && (n.lang = i.lang);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context32.next = 10;
              return this.request({
                path: "/geocoding/v1/reverse",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 10:
              c = _context32.sent;
              return _context32.abrupt("return", new d(c, function (a) {
                return h(a);
              }));
            case 12:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function reverseRaw(_x35, _x36) {
        return _reverseRaw.apply(this, arguments);
      }
      return reverseRaw;
    }()
    /**
     * Reverse geocoding and search finds places and addresses near any geographic coordinates.
     * Find places and addresses near geographic coordinates (reverse geocoding).
     */
  }, {
    key: "reverse",
    value: function () {
      var _reverse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(i, r) {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return this.reverseRaw(i, r);
            case 2:
              _context33.next = 4;
              return _context33.sent.value();
            case 4:
              return _context33.abrupt("return", _context33.sent);
            case 5:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function reverse(_x37, _x38) {
        return _reverse.apply(this, arguments);
      }
      return reverse;
    }()
    /**
     * The search endpoint lets you search for addresses, points of interest, and administrative areas. This is most commonly used for forward geocoding applications where you need to find the geographic coordinates of an address.
     * Search for location and other info using a place name or address (forward geocoding).
     */
  }, {
    key: "searchRaw",
    value: function () {
      var _searchRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!(i.text === null || i.text === void 0)) {
                _context34.next = 2;
                break;
              }
              throw new g("text", "Required parameter requestParameters.text was null or undefined when calling search.");
            case 2:
              n = {};
              i.text !== void 0 && (n.text = i.text), i.focusPointLat !== void 0 && (n["focus.point.lat"] = i.focusPointLat), i.focusPointLon !== void 0 && (n["focus.point.lon"] = i.focusPointLon), i.boundaryRectMinLat !== void 0 && (n["boundary.rect.min_lat"] = i.boundaryRectMinLat), i.boundaryRectMaxLat !== void 0 && (n["boundary.rect.max_lat"] = i.boundaryRectMaxLat), i.boundaryRectMinLon !== void 0 && (n["boundary.rect.min_lon"] = i.boundaryRectMinLon), i.boundaryRectMaxLon !== void 0 && (n["boundary.rect.max_lon"] = i.boundaryRectMaxLon), i.boundaryCircleLat !== void 0 && (n["boundary.circle.lat"] = i.boundaryCircleLat), i.boundaryCircleLon !== void 0 && (n["boundary.circle.lon"] = i.boundaryCircleLon), i.boundaryCircleRadius !== void 0 && (n["boundary.circle.radius"] = i.boundaryCircleRadius), i.boundaryCountry && (n["boundary.country"] = i.boundaryCountry.join(s.csv)), i.boundaryGid !== void 0 && (n["boundary.gid"] = i.boundaryGid), i.layers && (n.layers = i.layers.join(s.csv)), i.sources && (n.sources = i.sources.join(s.csv)), i.size !== void 0 && (n.size = i.size), i.lang !== void 0 && (n.lang = i.lang);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context34.next = 8;
              return this.request({
                path: "/geocoding/v1/search",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 8:
              c = _context34.sent;
              return _context34.abrupt("return", new d(c, function (a) {
                return h(a);
              }));
            case 10:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function searchRaw(_x39, _x40) {
        return _searchRaw.apply(this, arguments);
      }
      return searchRaw;
    }()
    /**
     * The search endpoint lets you search for addresses, points of interest, and administrative areas. This is most commonly used for forward geocoding applications where you need to find the geographic coordinates of an address.
     * Search for location and other info using a place name or address (forward geocoding).
     */
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(i, r) {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return this.searchRaw(i, r);
            case 2:
              _context35.next = 4;
              return _context35.sent.value();
            case 4:
              return _context35.abrupt("return", _context35.sent);
            case 5:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function search(_x41, _x42) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
    /**
     * The structured search endpoint lets you search for addresses, points of interest, and administrative areas. Rather than a single string which the API must infer meaning from, the structured search endpoint allows you to specify the known components upfront, which is useful in many forward geocoding workflows.
     * Find locations matching components (structured forward geocoding).
     */
  }, {
    key: "searchStructuredRaw",
    value: function () {
      var _searchStructuredRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(i, r) {
        var n, o, c;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              n = {};
              i.address !== void 0 && (n.address = i.address), i.neighbourhood !== void 0 && (n.neighbourhood = i.neighbourhood), i.borough !== void 0 && (n.borough = i.borough), i.locality !== void 0 && (n.locality = i.locality), i.county !== void 0 && (n.county = i.county), i.region !== void 0 && (n.region = i.region), i.postalcode !== void 0 && (n.postalcode = i.postalcode), i.country !== void 0 && (n.country = i.country), i.focusPointLat !== void 0 && (n["focus.point.lat"] = i.focusPointLat), i.focusPointLon !== void 0 && (n["focus.point.lon"] = i.focusPointLon), i.boundaryRectMinLat !== void 0 && (n["boundary.rect.min_lat"] = i.boundaryRectMinLat), i.boundaryRectMaxLat !== void 0 && (n["boundary.rect.max_lat"] = i.boundaryRectMaxLat), i.boundaryRectMinLon !== void 0 && (n["boundary.rect.min_lon"] = i.boundaryRectMinLon), i.boundaryRectMaxLon !== void 0 && (n["boundary.rect.max_lon"] = i.boundaryRectMaxLon), i.boundaryCircleLat !== void 0 && (n["boundary.circle.lat"] = i.boundaryCircleLat), i.boundaryCircleLon !== void 0 && (n["boundary.circle.lon"] = i.boundaryCircleLon), i.boundaryCircleRadius !== void 0 && (n["boundary.circle.radius"] = i.boundaryCircleRadius), i.boundaryCountry && (n["boundary.country"] = i.boundaryCountry.join(s.csv)), i.boundaryGid !== void 0 && (n["boundary.gid"] = i.boundaryGid), i.layers && (n.layers = i.layers.join(s.csv)), i.sources && (n.sources = i.sources.join(s.csv)), i.size !== void 0 && (n.size = i.size), i.lang !== void 0 && (n.lang = i.lang);
              o = {};
              this.configuration && this.configuration.apiKey && (n.api_key = this.configuration.apiKey("api_key"));
              _context36.next = 6;
              return this.request({
                path: "/geocoding/v1/search/structured",
                method: "GET",
                headers: o,
                query: n
              }, r);
            case 6:
              c = _context36.sent;
              return _context36.abrupt("return", new d(c, function (a) {
                return h(a);
              }));
            case 8:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function searchStructuredRaw(_x43, _x44) {
        return _searchStructuredRaw.apply(this, arguments);
      }
      return searchStructuredRaw;
    }()
    /**
     * The structured search endpoint lets you search for addresses, points of interest, and administrative areas. Rather than a single string which the API must infer meaning from, the structured search endpoint allows you to specify the known components upfront, which is useful in many forward geocoding workflows.
     * Find locations matching components (structured forward geocoding).
     */
  }, {
    key: "searchStructured",
    value: function () {
      var _searchStructured = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var i,
          r,
          _args37 = arguments;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              i = _args37.length > 0 && _args37[0] !== undefined ? _args37[0] : {};
              r = _args37.length > 1 ? _args37[1] : undefined;
              _context37.next = 4;
              return this.searchStructuredRaw(i, r);
            case 4:
              _context37.next = 6;
              return _context37.sent.value();
            case 6:
              return _context37.abrupt("return", _context37.sent);
            case 7:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function searchStructured() {
        return _searchStructured.apply(this, arguments);
      }
      return searchStructured;
    }()
  }]);
  return qn;
}(b);
var Cd = /*#__PURE__*/function (_qn) {
  _inherits(Cd, _qn);
  function Cd() {
    var _this5;
    _classCallCheck(this, Cd);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Cd).apply(this, arguments)), _this5.cache = /* @__PURE__ */new Map();
    return _this5;
  }
  /**
   * Autocomplete enables interactive search-as-you-type user experiences, suggesting places as you type, along with information that will help your users find the correct place quickly.
   *
   * To ensure a snappy user experience, recent successful searches are cached automatically.
   * We also recommend throttling (ex: via lodash) for most interactive applications.
   */
  _createClass(Cd, [{
    key: "autocomplete",
    value: function () {
      var _autocomplete2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(i, r) {
        var n, o, c, a;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              n = r === null ? "null" : typeof r == "function" ? r.toString() : JSON.stringify(r);
              o = JSON.stringify(i) + n;
              if (!this.cache.has(o)) {
                _context38.next = 4;
                break;
              }
              return _context38.abrupt("return", this.cache.get(o));
            case 4:
              _context38.next = 6;
              return _superPropGet(Cd, "autocomplete", this, 3)([i, r]);
            case 6:
              c = _context38.sent;
              if (this.cache.size >= 20) {
                a = this.cache.keys().next().value;
                this.cache.delete(a);
              }
              return _context38.abrupt("return", (this.cache.set(o, c), c));
            case 9:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function autocomplete(_x45, _x46) {
        return _autocomplete2.apply(this, arguments);
      }
      return autocomplete;
    }()
  }]);
  return Cd;
}(qn);
export { H as AccessFromJSON, Ce as AccessFromJSONTyped, W as AccessToJSON, z as AdminRegionFromJSON, Fe as AdminRegionFromJSONTyped, U as AdminRegionToJSON, K as AdministrativeFromJSON, xe as AdministrativeFromJSONTyped, V as AdministrativeToJSON, sr as AutoCostingOptionsAllOfFromJSON, Ie as AutoCostingOptionsAllOfFromJSONTyped, ur as AutoCostingOptionsAllOfToJSON, R as AutoCostingOptionsFromJSON, ke as AutoCostingOptionsFromJSONTyped, J as AutoCostingOptionsToJSON, Se as BASE_PATH, b as BaseAPI, gr as BaseCostingOptionsFromJSON, Me as BaseCostingOptionsFromJSONTyped, pr as BaseCostingOptionsToJSON, Mr as BaseTraceRequestFromJSON, ti as BaseTraceRequestFromJSONTyped, kr as BaseTraceRequestShapeMatchEnum, Er as BaseTraceRequestToJSON, Ar as BicycleCostingOptionsAllOfBicycleTypeEnum, Pr as BicycleCostingOptionsAllOfFromJSON, ni as BicycleCostingOptionsAllOfFromJSONTyped, Dr as BicycleCostingOptionsAllOfToJSON, _r as BicycleCostingOptionsBicycleTypeEnum, Ee as BicycleCostingOptionsFromJSON, Ae as BicycleCostingOptionsFromJSONTyped, Le as BicycleCostingOptionsToJSON, ri as BikeNetworkFromJSON, oi as BikeNetworkFromJSONTyped, ci as BikeNetworkToJSON, tr as BlobApiResponse, s as COLLECTION_FORMATS, be as Configuration, ai as ContourFromJSON, di as ContourFromJSONTyped, si as ContourToJSON, p as CoordinateFromJSON, ui as CoordinateFromJSONTyped, _ as CoordinateToJSON, Wr as CostingModel, Z as CostingModelFromJSON, li as CostingModelFromJSONTyped, zr as CostingModelToJSON, u as CostingOptionsFromJSON, Xe as CostingOptionsFromJSONTyped, l as CostingOptionsToJSON, Te as DefaultConfig, Nr as DirectionsOptionsDirectionsTypeEnum, f as DirectionsOptionsFromJSON, je as DirectionsOptionsFromJSONTyped, y as DirectionsOptionsToJSON, Sr as DistanceUnit, Qe as DistanceUnitFromJSON, Ye as DistanceUnitFromJSONTyped, br as DistanceUnitToJSON, gi as EdgeSignFromJSON, pi as EdgeSignFromJSONTyped, _i as EdgeSignToJSON, Kr as EdgeUse, X as EdgeUseFromJSON, fi as EdgeUseFromJSONTyped, Vr as EdgeUseToJSON, bi as EndNodeFromJSON, Ti as EndNodeFromJSONTyped, wi as EndNodeToJSON, Je as FetchError, Ni as GeoAttributesFromJSON, Ri as GeoAttributesFromJSONTyped, Ji as GeoAttributesToJSON, fo as GeoJSONGeometryBaseFromJSON, Ii as GeoJSONGeometryBaseFromJSONTyped, yo as GeoJSONGeometryBaseToJSON, po as GeoJSONGeometryBaseTypeEnum, lo as GeoJSONGeometryFromJSON, ki as GeoJSONGeometryFromJSONTyped, go as GeoJSONGeometryToJSON, mo as GeoJSONLineStringAllOfFromJSON, Mi as GeoJSONLineStringAllOfFromJSONTyped, Oo as GeoJSONLineStringAllOfToJSON, ro as GeoJSONLineStringFromJSON, Q as GeoJSONLineStringFromJSONTyped, Ci as GeoJSONLineStringToJSON, to as GeoJSONLineStringTypeEnum, So as GeoJSONPointAllOfFromJSON, Ei as GeoJSONPointAllOfFromJSONTyped, bo as GeoJSONPointAllOfToJSON, Fi as GeoJSONPointFromJSON, Y as GeoJSONPointFromJSONTyped, q as GeoJSONPointToJSON, oo as GeoJSONPointTypeEnum, wo as GeoJSONPolygonAllOfFromJSON, Ai as GeoJSONPolygonAllOfFromJSONTyped, No as GeoJSONPolygonAllOfToJSON, uo as GeoJSONPolygonFromJSON, j as GeoJSONPolygonFromJSONTyped, xi as GeoJSONPolygonToJSON, ao as GeoJSONPolygonTypeEnum, Cd as GeocodingApi, Jo as GeocodingObjectFromJSON, Li as GeocodingObjectFromJSONTyped, Co as GeocodingObjectToJSON, Nd as GeospatialApi, ko as HeightRequestFromJSON, Pi as HeightRequestFromJSONTyped, Fo as HeightRequestShapeFormatEnum, Di as HeightRequestToJSON, Bi as HeightResponseFromJSON, Gi as HeightResponseFromJSONTyped, Mo as HeightResponseToJSON, Lo as HighwayClassificationClassificationEnum, Hi as HighwayClassificationFromJSON, Wi as HighwayClassificationFromJSONTyped, Eo as HighwayClassificationSurfaceEnum, zi as HighwayClassificationToJSON, Ao as HighwayClassificationUseEnum, mi as IntersectingEdgeFromJSON, Oi as IntersectingEdgeFromJSONTyped, vi as IntersectingEdgeToJSON, Do as IsochroneCostingModel, Ui as IsochroneCostingModelFromJSON, Ki as IsochroneCostingModelFromJSONTyped, Bo as IsochroneCostingModelToJSON, Xi as IsochroneFeatureFromJSON, Qi as IsochroneFeatureFromJSONTyped, Yi as IsochroneFeatureToJSON, Wo as IsochroneFeatureTypeEnum, Vi as IsochronePropertiesFromJSON, $i as IsochronePropertiesFromJSONTyped, Go as IsochronePropertiesMetricEnum, Zi as IsochronePropertiesToJSON, Ko as IsochroneRequestFromJSON, qi as IsochroneRequestFromJSONTyped, ji as IsochroneRequestToJSON, et as IsochroneResponseFromJSON, it as IsochroneResponseFromJSONTyped, Zo as IsochroneResponseToJSON, Vo as IsochroneResponseTypeEnum, d as JSONApiResponse, ec as LocateDetailedEdgeCycleLaneEnum, at as LocateDetailedEdgeFromJSON, dt as LocateDetailedEdgeFromJSONTyped, jo as LocateDetailedEdgeSacScaleEnum, st as LocateDetailedEdgeToJSON, pt as LocateEdgeFromJSON, _t as LocateEdgeFromJSONTyped, ut as LocateEdgeInfoFromJSON, lt as LocateEdgeInfoFromJSONTyped, gt as LocateEdgeInfoToJSON, nc as LocateEdgeSideOfStreetEnum, ft as LocateEdgeToJSON, sc as LocateNodeAllOfFromJSON, Ot as LocateNodeAllOfFromJSONTyped, ac as LocateNodeAllOfIntersectionTypeEnum, uc as LocateNodeAllOfToJSON, yt as LocateNodeFromJSON, ht as LocateNodeFromJSONTyped, oc as LocateNodeIntersectionTypeEnum, mt as LocateNodeToJSON, vt as LocateObjectFromJSON, St as LocateObjectFromJSONTyped, gc as LocateObjectToJSON, m as ManeuverSignElementFromJSON, bt as ManeuverSignElementFromJSONTyped, O as ManeuverSignElementToJSON, Tt as ManeuverSignFromJSON, wt as ManeuverSignFromJSONTyped, Nt as ManeuverSignToJSON, Jr as MapMatchCostingModel, x as MapMatchCostingModelFromJSON, ei as MapMatchCostingModelFromJSONTyped, Cr as MapMatchCostingModelToJSON, vc as MapMatchRequestAllOfFromJSON, Ft as MapMatchRequestAllOfFromJSONTyped, Sc as MapMatchRequestAllOfToJSON, mc as MapMatchRequestFromJSON, Jt as MapMatchRequestFromJSONTyped, yc as MapMatchRequestShapeMatchEnum, Ct as MapMatchRequestToJSON, Pc as MapMatchRouteResponseAllOfFromJSON, Kt as MapMatchRouteResponseAllOfFromJSONTyped, Dc as MapMatchRouteResponseAllOfToJSON, zt as MapMatchRouteResponseFromJSON, Ut as MapMatchRouteResponseFromJSONTyped, Ac as MapMatchRouteResponseToJSON, ee as MapMatchTraceOptionsFromJSON, Rt as MapMatchTraceOptionsFromJSONTyped, ie as MapMatchTraceOptionsToJSON, Gc as MapMatchWaypointAllOfFromJSON, Vt as MapMatchWaypointAllOfFromJSONTyped, Hc as MapMatchWaypointAllOfToJSON, k as MapMatchWaypointFromJSON, ii as MapMatchWaypointFromJSONTyped, I as MapMatchWaypointToJSON, Fr as MapMatchWaypointTypeEnum, ae as MatchedPointFromJSON, $t as MatchedPointFromJSONTyped, de as MatchedPointToJSON, Wc as MatchedPointTypeEnum, Uc as MatrixCostingModel, se as MatrixCostingModelFromJSON, Zt as MatrixCostingModelFromJSONTyped, Kc as MatrixCostingModelToJSON, $c as MatrixDistanceFromJSON, Xt as MatrixDistanceFromJSONTyped, Zc as MatrixDistanceToJSON, Qc as MatrixRequestFromJSON, Qt as MatrixRequestFromJSONTyped, Yt as MatrixRequestToJSON, tn as MatrixResponseFromJSON, nn as MatrixResponseFromJSONTyped, jc as MatrixResponseToJSON, ia as MotorScooterCostingOptionsAllOfFromJSON, rn as MotorScooterCostingOptionsAllOfFromJSONTyped, ta as MotorScooterCostingOptionsAllOfToJSON, Pe as MotorScooterCostingOptionsFromJSON, De as MotorScooterCostingOptionsFromJSONTyped, Be as MotorScooterCostingOptionsToJSON, ra as MotorcycleCostingOptionsAllOfFromJSON, on as MotorcycleCostingOptionsAllOfFromJSONTyped, oa as MotorcycleCostingOptionsAllOfToJSON, Ge as MotorcycleCostingOptionsFromJSON, He as MotorcycleCostingOptionsFromJSONTyped, We as MotorcycleCostingOptionsToJSON, aa as NearestRoadsRequestFromJSON, cn as NearestRoadsRequestFromJSONTyped, an as NearestRoadsRequestToJSON, T as NodeIdFromJSON, tt as NodeIdFromJSONTyped, w as NodeIdToJSON, qr as NodeType, M as NodeTypeFromJSON, Si as NodeTypeFromJSONTyped, jr as NodeTypeToJSON, sa as OptimizedRouteRequestFromJSON, dn as OptimizedRouteRequestFromJSONTyped, sn as OptimizedRouteRequestToJSON, ze as PedestrianCostingOptionsFromJSON, Ue as PedestrianCostingOptionsFromJSONTyped, Ke as PedestrianCostingOptionsToJSON, Sn as PeliasGeoJSONFeatureFromJSON, bn as PeliasGeoJSONFeatureFromJSONTyped, Tn as PeliasGeoJSONFeatureToJSON, ya as PeliasGeoJSONFeatureTypeEnum, _a as PeliasGeoJSONPropertiesAccuracyEnum, pn as PeliasGeoJSONPropertiesAddendumFromJSON, _n as PeliasGeoJSONPropertiesAddendumFromJSONTyped, un as PeliasGeoJSONPropertiesAddendumOsmFromJSON, ln as PeliasGeoJSONPropertiesAddendumOsmFromJSONTyped, gn as PeliasGeoJSONPropertiesAddendumOsmToJSON, fn as PeliasGeoJSONPropertiesAddendumToJSON, mn as PeliasGeoJSONPropertiesFromJSON, On as PeliasGeoJSONPropertiesFromJSONTyped, vn as PeliasGeoJSONPropertiesToJSON, ga as PeliasLayer, yn as PeliasLayerFromJSON, hn as PeliasLayerFromJSONTyped, pa as PeliasLayerToJSON, h as PeliasResponseFromJSON, Jn as PeliasResponseFromJSONTyped, wn as PeliasResponseGeocodingFromJSON, Nn as PeliasResponseGeocodingFromJSONTyped, Rn as PeliasResponseGeocodingToJSON, va as PeliasResponseToJSON, Sa as PeliasSource, ba as PeliasSourceFromJSON, Cn as PeliasSourceFromJSONTyped, Ta as PeliasSourceToJSON, g as RequiredError, Re as ResponseError, C as RestrictionsFromJSON, nt as RestrictionsFromJSONTyped, F as RestrictionsToJSON, $r as RoadClass, S as RoadClassFromJSON, yi as RoadClassFromJSONTyped, Zr as RoadClassToJSON, At as RouteLegFromJSON, Lt as RouteLegFromJSONTyped, Pt as RouteLegToJSON, Nc as RouteManeuverBssManeuverTypeEnum, kt as RouteManeuverFromJSON, It as RouteManeuverFromJSONTyped, Mt as RouteManeuverToJSON, wc as RouteManeuverTravelTypeEnum, Fa as RouteRequestFromJSON, kn as RouteRequestFromJSONTyped, In as RouteRequestToJSON, P as RouteResponseFromJSON, Mn as RouteResponseFromJSONTyped, ka as RouteResponseToJSON, oe as RouteResponseTripFromJSON, Wt as RouteResponseTripFromJSONTyped, ce as RouteResponseTripToJSON, ne as RouteSummaryFromJSON, Et as RouteSummaryFromJSONTyped, re as RouteSummaryToJSON, Rd as RoutingApi, Ma as RoutingResponseWaypointAllOfFromJSON, En as RoutingResponseWaypointAllOfFromJSONTyped, Ea as RoutingResponseWaypointAllOfToJSON, Dt as RoutingResponseWaypointFromJSON, Bt as RoutingResponseWaypointFromJSONTyped, Gt as RoutingResponseWaypointToJSON, Fc as RoutingResponseWaypointTypeEnum, Pa as RoutingWaypointAllOfFromJSON, An as RoutingWaypointAllOfFromJSONTyped, Aa as RoutingWaypointAllOfPreferredSideEnum, ue as RoutingWaypointAllOfSearchFilterFromJSON, Fn as RoutingWaypointAllOfSearchFilterFromJSONTyped, le as RoutingWaypointAllOfSearchFilterToJSON, Da as RoutingWaypointAllOfToJSON, A as RoutingWaypointFromJSON, xn as RoutingWaypointFromJSONTyped, Ra as RoutingWaypointPreferredSideEnum, L as RoutingWaypointToJSON, Na as RoutingWaypointTypeEnum, Ka as SimpleRoutingWaypointAllOfFromJSON, Pn as SimpleRoutingWaypointAllOfFromJSONTyped, Va as SimpleRoutingWaypointAllOfToJSON, za as SimpleRoutingWaypointAllOfTypeEnum, Ha as SimpleRoutingWaypointFromJSON, Ln as SimpleRoutingWaypointFromJSONTyped, Wa as SimpleRoutingWaypointToJSON, Ba as SimpleRoutingWaypointTypeEnum, rt as SpeedsFromJSON, ot as SpeedsFromJSONTyped, ct as SpeedsToJSON, Yo as SpeedsTypeEnum, nr as TextApiResponse, Za as TraceAttributeFilterOptionsActionEnum, Qa as TraceAttributeFilterOptionsFromJSON, Bn as TraceAttributeFilterOptionsFromJSONTyped, Ya as TraceAttributeFilterOptionsToJSON, $a as TraceAttributeKey, ge as TraceAttributeKeyFromJSON, Dn as TraceAttributeKeyFromJSONTyped, pe as TraceAttributeKeyToJSON, ye as TraceAttributesBaseResponseFromJSON, Hn as TraceAttributesBaseResponseFromJSONTyped, he as TraceAttributesBaseResponseToJSON, ad as TraceAttributesRequestAllOfFiltersActionEnum, me as TraceAttributesRequestAllOfFiltersFromJSON, Wn as TraceAttributesRequestAllOfFiltersFromJSONTyped, Oe as TraceAttributesRequestAllOfFiltersToJSON, pd as TraceAttributesRequestAllOfFromJSON, Kn as TraceAttributesRequestAllOfFromJSONTyped, _d as TraceAttributesRequestAllOfToJSON, ld as TraceAttributesRequestFromJSON, zn as TraceAttributesRequestFromJSONTyped, sd as TraceAttributesRequestShapeMatchEnum, Un as TraceAttributesRequestToJSON, md as TraceAttributesResponseAllOfFromJSON, Zn as TraceAttributesResponseAllOfFromJSONTyped, Od as TraceAttributesResponseAllOfToJSON, Vn as TraceAttributesResponseFromJSON, $n as TraceAttributesResponseFromJSONTyped, yd as TraceAttributesResponseToJSON, id as TraceEdgeBicycleTypeEnum, nd as TraceEdgeCycleLaneEnum, _e as TraceEdgeFromJSON, Gn as TraceEdgeFromJSONTyped, ed as TraceEdgePedestrianTypeEnum, rd as TraceEdgeSidewalkEnum, qa as TraceEdgeSurfaceEnum, fe as TraceEdgeToJSON, td as TraceEdgeTransitTypeEnum, ja as TraceEdgeVehicleTypeEnum, bc as TravelMode, te as TravelModeFromJSON, xt as TravelModeFromJSONTyped, Tc as TravelModeToJSON, Xr as Traversability, v as TraversabilityFromJSON, hi as TraversabilityFromJSONTyped, Qr as TraversabilityToJSON, Sd as TruckCostingOptionsAllOfFromJSON, Xn as TruckCostingOptionsAllOfFromJSONTyped, bd as TruckCostingOptionsAllOfToJSON, Ve as TruckCostingOptionsFromJSON, $e as TruckCostingOptionsFromJSONTyped, Ze as TruckCostingOptionsToJSON, Qn as TzResponseFromJSON, Yn as TzResponseFromJSONTyped, wd as TzResponseToJSON, Tr as ValhallaLanguages, $ as ValhallaLanguagesFromJSON, qe as ValhallaLanguagesFromJSONTyped, wr as ValhallaLanguagesToJSON, kc as ValhallaLongUnits, N as ValhallaLongUnitsFromJSON, Ht as ValhallaLongUnitsFromJSONTyped, Ic as ValhallaLongUnitsToJSON, ir as VoidApiResponse, qt as WarningFromJSON, jt as WarningFromJSONTyped, en as WarningToJSON, er as canConsumeForm, t as exists, rr as instanceOfAccess, or as instanceOfAdminRegion, cr as instanceOfAdministrative, ar as instanceOfAutoCostingOptions, dr as instanceOfAutoCostingOptionsAllOf, lr as instanceOfBaseCostingOptions, Ir as instanceOfBaseTraceRequest, fr as instanceOfBicycleCostingOptions, Lr as instanceOfBicycleCostingOptionsAllOf, Br as instanceOfBikeNetwork, Gr as instanceOfContour, Hr as instanceOfCoordinate, vr as instanceOfCostingOptions, Rr as instanceOfDirectionsOptions, Ur as instanceOfEdgeSign, eo as instanceOfEndNode, io as instanceOfGeoAttributes, _o as instanceOfGeoJSONGeometryBase, no as instanceOfGeoJSONLineString, ho as instanceOfGeoJSONLineStringAllOf, co as instanceOfGeoJSONPoint, vo as instanceOfGeoJSONPointAllOf, so as instanceOfGeoJSONPolygon, To as instanceOfGeoJSONPolygonAllOf, Ro as instanceOfGeocodingObject, xo as instanceOfHeightRequest, Io as instanceOfHeightResponse, Po as instanceOfHighwayClassification, Yr as instanceOfIntersectingEdge, zo as instanceOfIsochroneFeature, Ho as instanceOfIsochroneProperties, Uo as instanceOfIsochroneRequest, $o as instanceOfIsochroneResponse, ic as instanceOfLocateDetailedEdge, rc as instanceOfLocateEdge, tc as instanceOfLocateEdgeInfo, cc as instanceOfLocateNode, dc as instanceOfLocateNodeAllOf, lc as instanceOfLocateObject, _c as instanceOfManeuverSign, pc as instanceOfManeuverSignElement, hc as instanceOfMapMatchRequest, Oc as instanceOfMapMatchRequestAllOf, Ec as instanceOfMapMatchRouteResponse, Lc as instanceOfMapMatchRouteResponseAllOf, fc as instanceOfMapMatchTraceOptions, xr as instanceOfMapMatchWaypoint, Bc as instanceOfMapMatchWaypointAllOf, zc as instanceOfMatchedPoint, Vc as instanceOfMatrixDistance, Xc as instanceOfMatrixRequest, qc as instanceOfMatrixResponse, yr as instanceOfMotorScooterCostingOptions, ea as instanceOfMotorScooterCostingOptionsAllOf, hr as instanceOfMotorcycleCostingOptions, na as instanceOfMotorcycleCostingOptionsAllOf, ca as instanceOfNearestRoadsRequest, Xo as instanceOfNodeId, da as instanceOfOptimizedRouteRequest, mr as instanceOfPedestrianCostingOptions, ha as instanceOfPeliasGeoJSONFeature, fa as instanceOfPeliasGeoJSONProperties, la as instanceOfPeliasGeoJSONPropertiesAddendum, ua as instanceOfPeliasGeoJSONPropertiesAddendumOsm, Oa as instanceOfPeliasResponse, ma as instanceOfPeliasResponseGeocoding, Qo as instanceOfRestrictions, Cc as instanceOfRouteLeg, Rc as instanceOfRouteManeuver, Ca as instanceOfRouteRequest, xa as instanceOfRouteResponse, Mc as instanceOfRouteResponseTrip, Jc as instanceOfRouteSummary, xc as instanceOfRoutingResponseWaypoint, Ia as instanceOfRoutingResponseWaypointAllOf, Ja as instanceOfRoutingWaypoint, La as instanceOfRoutingWaypointAllOf, wa as instanceOfRoutingWaypointAllOfSearchFilter, Ga as instanceOfSimpleRoutingWaypoint, Ua as instanceOfSimpleRoutingWaypointAllOf, qo as instanceOfSpeeds, Xa as instanceOfTraceAttributeFilterOptions, cd as instanceOfTraceAttributesBaseResponse, ud as instanceOfTraceAttributesRequest, gd as instanceOfTraceAttributesRequestAllOf, dd as instanceOfTraceAttributesRequestAllOfFilters, fd as instanceOfTraceAttributesResponse, hd as instanceOfTraceAttributesResponseAllOf, od as instanceOfTraceEdge, Or as instanceOfTruckCostingOptions, vd as instanceOfTruckCostingOptionsAllOf, Td as instanceOfTzResponse, Yc as instanceOfWarning, jn as mapValues, B as querystring };